/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** The `Byte` scalar type represents non-fractional whole numeric values. Byte can represent values between 0 and 255. */
  Byte: { input: any; output: any; }
  /** The `DateTime` scalar represents an ISO-8601 compliant date time type. */
  DateTime: { input: any; output: any; }
  /** The built-in `Decimal` scalar type. */
  Decimal: { input: any; output: any; }
  /** The `Long` scalar type represents non-fractional signed whole 64-bit numeric values. Long can represent values between -(2^63) and 2^63 - 1. */
  Long: { input: any; output: any; }
};

export type Acknowledge = {
  __typename?: 'Acknowledge';
  success: Scalars['Boolean']['output'];
};

export type AcknowledgeId = {
  __typename?: 'AcknowledgeId';
  id: Scalars['String']['output'];
};

export enum ActivityAction {
  Dislike = 'DISLIKE',
  Emailed = 'EMAILED',
  Like = 'LIKE',
  Pick = 'PICK',
  RemoveDislike = 'REMOVE_DISLIKE',
  RemoveEmailed = 'REMOVE_EMAILED',
  RemoveLike = 'REMOVE_LIKE',
  RemovePick = 'REMOVE_PICK',
  RemoveShown = 'REMOVE_SHOWN',
  Shown = 'SHOWN'
}

export type ActivityUnitViewModel = {
  __typename?: 'ActivityUnitViewModel';
  bathrooms?: Maybe<Scalars['String']['output']>;
  bedrooms?: Maybe<Scalars['String']['output']>;
  closed?: Maybe<Scalars['DateTime']['output']>;
  currentPrice?: Maybe<Scalars['Float']['output']>;
  currentStatus?: Maybe<Scalars['String']['output']>;
  dom?: Maybe<Scalars['Int']['output']>;
  domAffectedByPandemic: Scalars['Boolean']['output'];
  floorLine?: Maybe<Scalars['String']['output']>;
  floorNumber?: Maybe<Scalars['Int']['output']>;
  hasMedia: Scalars['Boolean']['output'];
  hasWebLinks: Scalars['Boolean']['output'];
  listDate?: Maybe<Scalars['DateTime']['output']>;
  listingCategoryId?: Maybe<ListingCategoryType>;
  listingId: Scalars['Int']['output'];
  listingNumber?: Maybe<Scalars['String']['output']>;
  pricePerSqft?: Maybe<Scalars['Float']['output']>;
  squareFootage?: Maybe<Scalars['String']['output']>;
  unitIdentifier?: Maybe<Scalars['String']['output']>;
  updateDateTime?: Maybe<Scalars['DateTime']['output']>;
  verified: Scalars['Boolean']['output'];
};

export type AddCustomerInput = {
  addressDetails: Array<AddressPersonInfoInput>;
  agentNewMatchSettings?: InputMaybe<Array<Scalars['Int']['input']>>;
  customerNewMatchSettings?: InputMaybe<Array<Scalars['Int']['input']>>;
  email: Array<EmailPersonInfoInput>;
  firstName: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
  lastName: Scalars['String']['input'];
  otherInfo: Array<PersonAttributeTextInput>;
  phone: Array<PhonePersonInfoInput>;
  primaryCustomerId?: InputMaybe<Scalars['Int']['input']>;
  profileImage?: InputMaybe<RpFileInput>;
  sharedNewMatchSettings?: InputMaybe<Array<Scalars['Int']['input']>>;
  showWarnOnCloseSettings: Scalars['Boolean']['input'];
};

export type AddListingActivityInput = {
  action: ActivityAction;
  customersIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  moveNmFolders?: InputMaybe<Scalars['Boolean']['input']>;
  nmRecordIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  selectedListingsIds: Array<Scalars['Int']['input']>;
};

export type AddListingCommentInput = {
  comment: Scalars['String']['input'];
  customerCollaborationId: Scalars['Int']['input'];
  listingId: Scalars['Int']['input'];
};

export type AddressCriteria = {
  __typename?: 'AddressCriteria';
  id?: Maybe<Scalars['Int']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
};

export type AddressCriteriaInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
};

export type AddressPersonInfo = {
  __typename?: 'AddressPersonInfo';
  addressLine1: Scalars['String']['output'];
  addressLine2?: Maybe<Scalars['String']['output']>;
  addressType: AddressType;
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
  postCode: Scalars['String']['output'];
  state: Scalars['String']['output'];
};

export type AddressPersonInfoInput = {
  addressLine1: Scalars['String']['input'];
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  addressType: AddressType;
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  postCode: Scalars['String']['input'];
  state: Scalars['String']['input'];
};

export enum AddressType {
  Home = 'HOME',
  Office = 'OFFICE',
  Other = 'OTHER',
  Work = 'WORK'
}

export type AgentBasicInfo = {
  __typename?: 'AgentBasicInfo';
  companyId: Scalars['Int']['output'];
  companyName: Scalars['String']['output'];
  fullName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  profileImageUrl: Scalars['String']['output'];
};

export type AgentExtensions = {
  __typename?: 'AgentExtensions';
  agentBasicInfo: AgentBasicInfo;
  agentPreferences: AgentPreferences;
  agentsListByOmniSearch: Array<AgentOmniSearchModel>;
};


export type AgentExtensionsAgentBasicInfoArgs = {
  agentId: Scalars['Int']['input'];
};


export type AgentExtensionsAgentsListByOmniSearchArgs = {
  text: Scalars['String']['input'];
};

export type AgentOmniSearchModel = {
  __typename?: 'AgentOmniSearchModel';
  agentId: Scalars['Int']['output'];
  agentName: Scalars['String']['output'];
  companyName: Scalars['String']['output'];
  inactive: Scalars['Boolean']['output'];
};

export type AgentPreferences = {
  __typename?: 'AgentPreferences';
  addressSortBy?: Maybe<Scalars['String']['output']>;
  agentId: Scalars['Int']['output'];
  companyLogoUrl?: Maybe<Scalars['String']['output']>;
  customerCollaborationAllowed?: Maybe<Scalars['Boolean']['output']>;
  customerGridSettings?: Maybe<Scalars['String']['output']>;
  dataIssueEmail?: Maybe<Scalars['String']['output']>;
  defaultListingCategory?: Maybe<Scalars['Int']['output']>;
  detailToolbarCollapsed?: Maybe<Scalars['Boolean']['output']>;
  enableCriteriaSummaryPreview?: Maybe<Scalars['Boolean']['output']>;
  favouriteReportCriteria?: Maybe<Scalars['String']['output']>;
  hideEmptyListingDetails?: Maybe<Scalars['Boolean']['output']>;
  maxSearchResults?: Maybe<Scalars['Int']['output']>;
  opReportSettings?: Maybe<Scalars['String']['output']>;
  searchOption?: Maybe<Scalars['String']['output']>;
  searchResultToolbarCollapsed?: Maybe<Scalars['Boolean']['output']>;
  searchResultToolbarOption?: Maybe<Scalars['String']['output']>;
  showInviteToMyPlaceNYCBanner?: Maybe<Scalars['Boolean']['output']>;
  showMapSelectedArea?: Maybe<Scalars['Boolean']['output']>;
  stickyGridTools?: Maybe<Scalars['Boolean']['output']>;
  useMarketingCompanyLogo?: Maybe<Scalars['Boolean']['output']>;
  viewMapOnQuickSearch?: Maybe<Scalars['Boolean']['output']>;
};

export type AgentSettings = {
  __typename?: 'AgentSettings';
  commentEmailAlert: EmailAlertTimeOption;
  confirmAppointmentEmailAlert: EmailAlertTimeOption;
  declineAppointmentEmailAlert: EmailAlertTimeOption;
  dislikedEmailAlert: EmailAlertTimeOption;
  likedEmailAlert: EmailAlertTimeOption;
  pickListedEmailAlert: EmailAlertTimeOption;
  removeListingEmailAlert: EmailAlertTimeOption;
  requestAppointmentEmailAlert: EmailAlertTimeOption;
};

export type AgentsCriteria = {
  __typename?: 'AgentsCriteria';
  ids?: Maybe<Array<Scalars['Int']['output']>>;
  names?: Maybe<Array<Scalars['String']['output']>>;
};

export type AgentsCriteriaInput = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  names?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum AirConditioningType {
  Central = 'CENTRAL',
  Individual = 'INDIVIDUAL',
  No = 'NO',
  ThroughWall = 'THROUGH_WALL',
  Unknown = 'UNKNOWN',
  Window = 'WINDOW',
  Yes = 'YES',
  YesTypeUnknown = 'YES_TYPE_UNKNOWN'
}

export enum AndOr {
  And = 'AND',
  Or = 'OR'
}

export type ApartmentMediaExternalLinkViewModel = {
  __typename?: 'ApartmentMediaExternalLinkViewModel';
  description: Scalars['String']['output'];
  imageUrl: Scalars['String']['output'];
  propertyId?: Maybe<Scalars['Int']['output']>;
  tooltip: Scalars['String']['output'];
};

export enum ApplyPolicy {
  AfterResolver = 'AFTER_RESOLVER',
  BeforeResolver = 'BEFORE_RESOLVER',
  Validation = 'VALIDATION'
}

export type AppointmentDeletedEventInput = {
  appointmentId: Scalars['Int']['input'];
  createId: Scalars['Int']['input'];
  customerCollaborationId: Scalars['Int']['input'];
};

export type AppointmentEventInput = {
  appointmentCreatorId: Scalars['Int']['input'];
  appointmentId: Scalars['Int']['input'];
  customerCollaborationId: Scalars['Int']['input'];
  listingId: Scalars['Int']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
  range: DateRangeInput;
};

export type AppointmentMutationExtensions = {
  __typename?: 'AppointmentMutationExtensions';
  confirm: Scalars['Boolean']['output'];
  create: CollaborationAppointment;
  decline: Scalars['Boolean']['output'];
  markAsViewed: Scalars['Boolean']['output'];
  softDelete: Scalars['Boolean']['output'];
  update: Scalars['Boolean']['output'];
};


export type AppointmentMutationExtensionsConfirmArgs = {
  appointmentId: Scalars['Int']['input'];
};


export type AppointmentMutationExtensionsCreateArgs = {
  input: CreateAgentAppointmentInput;
};


export type AppointmentMutationExtensionsDeclineArgs = {
  appointmentId: Scalars['Int']['input'];
};


export type AppointmentMutationExtensionsMarkAsViewedArgs = {
  appointmentsIds: Array<Scalars['Int']['input']>;
};


export type AppointmentMutationExtensionsSoftDeleteArgs = {
  input: SoftDeleteAppointmentsInput;
};


export type AppointmentMutationExtensionsUpdateArgs = {
  input: UpdateAgentAppointmentInput;
};

export enum AppointmentStatus {
  Confirmed = 'CONFIRMED',
  Declined = 'DECLINED',
  Pending = 'PENDING'
}

export type AppointmentUpdatedEventInput = {
  appointmentCreatorId: Scalars['Int']['input'];
  appointmentId: Scalars['Int']['input'];
  customerCollaborationId: Scalars['Int']['input'];
  listingId: Scalars['Int']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
  newMessage?: InputMaybe<Scalars['String']['input']>;
  newRange?: InputMaybe<DateRangeInput>;
  range: DateRangeInput;
};

export type AppointmentViewModel = {
  __typename?: 'AppointmentViewModel';
  agentStatus: NotificationsGraphQl_AppointmentStatus;
  comment?: Maybe<Scalars['String']['output']>;
  createId: Scalars['Int']['output'];
  customerStatus: NotificationsGraphQl_AppointmentStatus;
  endDateTime?: Maybe<Scalars['DateTime']['output']>;
  isCreatedByAgent: Scalars['Boolean']['output'];
  startDateTime?: Maybe<Scalars['DateTime']['output']>;
  updateId?: Maybe<Scalars['Int']['output']>;
};

export type AppointmentsExtensions = {
  __typename?: 'AppointmentsExtensions';
  collaborationAppointment: CollaborationAppointment;
  collaborationAppointments: Array<CollaborationAppointment>;
  top1CollaborationAppointmentsPerCustomer: Array<KeyValuePairOfInt32AndCollaborationAppointmentPreview>;
};


export type AppointmentsExtensionsCollaborationAppointmentArgs = {
  id: Scalars['Int']['input'];
};


export type AppointmentsExtensionsCollaborationAppointmentsArgs = {
  input: GetCollaborationAppointmentsInput;
};


export type AppointmentsExtensionsTop1CollaborationAppointmentsPerCustomerArgs = {
  input: GetTop1CollaborationAppointmentsPerCustomerInput;
};

export type AttachedSavedSearch = {
  __typename?: 'AttachedSavedSearch';
  attachedSavedSearchId: Scalars['Int']['output'];
  attachedSavedSearchName: Scalars['String']['output'];
};

export type AutoSavedSearch = {
  __typename?: 'AutoSavedSearch';
  agentId: Scalars['Int']['output'];
  criteria?: Maybe<SearchCriteria>;
  date: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
};

export type BathroomsCriteria = {
  __typename?: 'BathroomsCriteria';
  minMax?: Maybe<MinMaxCriteria>;
  values?: Maybe<ValuesCriteria>;
};

export type BathroomsCriteriaInput = {
  minMax?: InputMaybe<MinMaxCriteriaInput>;
  values?: InputMaybe<ValuesCriteriaInput>;
};

export type BedroomsCriteria = {
  __typename?: 'BedroomsCriteria';
  minMax?: Maybe<MinMaxCriteria>;
  values?: Maybe<ValuesCriteria>;
};

export type BedroomsCriteriaInput = {
  minMax?: InputMaybe<MinMaxCriteriaInput>;
  values?: InputMaybe<ValuesCriteriaInput>;
};

export type BonusOffered = {
  __typename?: 'BonusOffered';
  description?: Maybe<Scalars['String']['output']>;
  expirationDate?: Maybe<Scalars['DateTime']['output']>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  value?: Maybe<ValueOfYesNoUnknown>;
};

export enum BuildingActivity {
  ActiveUnits = 'ACTIVE_UNITS',
  AllUnits = 'ALL_UNITS',
  ComingSoonUnits = 'COMING_SOON_UNITS',
  ContractSigned = 'CONTRACT_SIGNED',
  LeaseSigned = 'LEASE_SIGNED',
  ListingActivity = 'LISTING_ACTIVITY',
  PastRented = 'PAST_RENTED',
  PastSold = 'PAST_SOLD'
}

export type BuildingContract = {
  __typename?: 'BuildingContract';
  companyName: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type BuildingContractsCriteria = {
  __typename?: 'BuildingContractsCriteria';
  landlords?: Maybe<Array<Scalars['String']['output']>>;
  managementCompanies?: Maybe<Array<Scalars['String']['output']>>;
  owners?: Maybe<Array<Scalars['String']['output']>>;
};

export type BuildingContractsCriteriaInput = {
  landlords?: InputMaybe<Array<Scalars['String']['input']>>;
  managementCompanies?: InputMaybe<Array<Scalars['String']['input']>>;
  owners?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum BuildingStorageType {
  BikeRoom = 'BIKE_ROOM',
  BikeStorage = 'BIKE_STORAGE',
  ColdStorage = 'COLD_STORAGE',
  CommonStorage = 'COMMON_STORAGE',
  PrivateStorage = 'PRIVATE_STORAGE',
  PrivateStorageAvailableForPurchase = 'PRIVATE_STORAGE_AVAILABLE_FOR_PURCHASE',
  StorageOnly = 'STORAGE_ONLY',
  WineStorage = 'WINE_STORAGE'
}

export type ClusterBounds = {
  __typename?: 'ClusterBounds';
  bottomRight: MapCoordinate;
  topLeft: MapCoordinate;
};

export type ClusterItem = {
  __typename?: 'ClusterItem';
  bounds: ClusterBounds;
  coordinate: MapCoordinate;
  count: Scalars['Long']['output'];
  topProperties: Array<KeyValuePairOfInt32AndGeoInfo__>;
};

export type CollaborationAgentViewModel = {
  __typename?: 'CollaborationAgentViewModel';
  avatarUrl?: Maybe<Scalars['String']['output']>;
  ccEmails: Array<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  fullName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  settings: AgentSettings;
};

export type CollaborationAppointment = {
  __typename?: 'CollaborationAppointment';
  agentStatus: AppointmentStatus;
  appointmentId: Scalars['Int']['output'];
  collaborationId: Scalars['Int']['output'];
  comment?: Maybe<Scalars['String']['output']>;
  createId: Scalars['Int']['output'];
  creator: Person;
  customer: Person;
  customerId: Scalars['Int']['output'];
  customerPhoneNumber?: Maybe<Scalars['String']['output']>;
  customerStatus: AppointmentStatus;
  dateCreated: Scalars['DateTime']['output'];
  dateUpdated?: Maybe<Scalars['DateTime']['output']>;
  endDateTime: Scalars['DateTime']['output'];
  isAgentCreator: Scalars['Boolean']['output'];
  isOwnerAgentCreator: Scalars['Boolean']['output'];
  listing: Listing;
  listingId: Scalars['Int']['output'];
  sharingType?: Maybe<CustomerSharingOptions>;
  startDateTime: Scalars['DateTime']['output'];
  updateId?: Maybe<Scalars['Int']['output']>;
  updater?: Maybe<Person>;
  viewed: Scalars['Boolean']['output'];
};

export type CollaborationAppointmentPreview = {
  __typename?: 'CollaborationAppointmentPreview';
  appointmentId: Scalars['Int']['output'];
  collaborationId: Scalars['Int']['output'];
  comment?: Maybe<Scalars['String']['output']>;
  endDateTime: Scalars['DateTime']['output'];
  listingId: Scalars['Int']['output'];
  startDateTime: Scalars['DateTime']['output'];
};

export type CollaborationCustomerViewModel = {
  __typename?: 'CollaborationCustomerViewModel';
  avatarUrl?: Maybe<Scalars['String']['output']>;
  ccEmails: Array<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  fullName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  settings: CustomerSettings;
};

export type CollaborationPortfolioViewModel = {
  __typename?: 'CollaborationPortfolioViewModel';
  agent: CollaborationAgentViewModel;
  childCustomers: Array<CollaborationCustomerViewModel>;
  companyId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  primaryCustomer: CollaborationCustomerViewModel;
  sharedWithAgents: Array<CollaborationAgentViewModel>;
};

export type CollaborationViewModel = {
  __typename?: 'CollaborationViewModel';
  customerCollaborationId: Scalars['Int']['output'];
  customerId: Scalars['Int']['output'];
  dateCreated?: Maybe<Scalars['DateTime']['output']>;
  expirationDate?: Maybe<Scalars['DateTime']['output']>;
  status: InvitationStatus;
};

export type CommentCreatedInput = {
  commentId: Scalars['Int']['input'];
  creatorId: Scalars['Int']['input'];
  customerCollaborationId: Scalars['Int']['input'];
  date: Scalars['DateTime']['input'];
  listingId: Scalars['Int']['input'];
  message: Scalars['String']['input'];
};

export type CommentUpdatedInput = {
  commentId: Scalars['Int']['input'];
  creatorId: Scalars['Int']['input'];
  customerCollaborationId: Scalars['Int']['input'];
  date: Scalars['DateTime']['input'];
  listingId: Scalars['Int']['input'];
  message: Scalars['String']['input'];
  newMessage: Scalars['String']['input'];
};

export type CommentViewModel = {
  __typename?: 'CommentViewModel';
  text: Scalars['String']['output'];
};

export type CommentsExtensions = {
  __typename?: 'CommentsExtensions';
  listingDialogComments: GetListingDialogCommentsOutput;
  listingDialogs: GetListingDialogOutput;
  listingDialogsCount: Scalars['Int']['output'];
  listingNewCommentsCount: Scalars['Int']['output'];
};


export type CommentsExtensionsListingDialogCommentsArgs = {
  input: GetListingDialogCommentsInput;
};


export type CommentsExtensionsListingDialogsArgs = {
  input: GetListingDialogsInput;
};


export type CommentsExtensionsListingDialogsCountArgs = {
  input: GetListingDialogsCountInput;
};


export type CommentsExtensionsListingNewCommentsCountArgs = {
  listingId: Scalars['Int']['input'];
};

export type CompanyOfficeBasicInfo = {
  __typename?: 'CompanyOfficeBasicInfo';
  officeIds: Array<Scalars['Int']['output']>;
  officeName: Scalars['String']['output'];
};

export type CreateAgentAppointmentInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  customerId: Scalars['Int']['input'];
  end: Scalars['DateTime']['input'];
  hasToAddToPickList?: InputMaybe<Scalars['Boolean']['input']>;
  listingId: Scalars['Int']['input'];
  newMatchRecordId?: InputMaybe<Scalars['Int']['input']>;
  start: Scalars['DateTime']['input'];
};

export type CreateFolderInput = {
  customerId?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
};

export type CustomFolder = {
  __typename?: 'CustomFolder';
  appointmentsCount?: Maybe<Scalars['Int']['output']>;
  attachedListingsPhotoPreview: Array<Scalars['String']['output']>;
  attachedSavedSearches: Array<AttachedSavedSearch>;
  commentsCount?: Maybe<Scalars['Int']['output']>;
  createDate: Scalars['DateTime']['output'];
  creatorFullName: Scalars['String']['output'];
  creatorProfileImageUrl?: Maybe<Scalars['String']['output']>;
  customerId?: Maybe<Scalars['Int']['output']>;
  folderId: Scalars['Int']['output'];
  folderName: Scalars['String']['output'];
  hasNewAppointments?: Maybe<Scalars['Boolean']['output']>;
  hasNewComments?: Maybe<Scalars['Boolean']['output']>;
  hasNewLikedListings: Scalars['Boolean']['output'];
  hasNewListings: Scalars['Boolean']['output'];
  likesCount: Scalars['Int']['output'];
  listingsCount: Scalars['Int']['output'];
  newMatchesCount: Scalars['Int']['output'];
};

export type CustomerActivityHistory = {
  __typename?: 'CustomerActivityHistory';
  actionDate?: Maybe<Scalars['DateTime']['output']>;
  actionId: Scalars['String']['output'];
  customerName: Scalars['String']['output'];
  isNew: Scalars['Boolean']['output'];
};

export type CustomerAttributesData = {
  __typename?: 'CustomerAttributesData';
  birthday: Array<Scalars['String']['output']>;
  customerId: Scalars['Int']['output'];
  facebook: Array<Scalars['String']['output']>;
  instagram: Array<Scalars['String']['output']>;
  linkedIn: Array<Scalars['String']['output']>;
  nickname: Array<Scalars['String']['output']>;
  relationship: Array<Scalars['String']['output']>;
  title: Array<Scalars['String']['output']>;
  twitter: Array<Scalars['String']['output']>;
  url: Array<Scalars['String']['output']>;
  userAvatar?: Maybe<Scalars['String']['output']>;
};

export type CustomerCollaborationStatsViewModel = {
  __typename?: 'CustomerCollaborationStatsViewModel';
  customerId: Scalars['Int']['output'];
  latestAppointmentDate?: Maybe<Scalars['DateTime']['output']>;
  latestCommentDate?: Maybe<Scalars['DateTime']['output']>;
  newAppointmentsCount: Scalars['Int']['output'];
  newCommentsCount: Scalars['Int']['output'];
  totalAppointmentsCount: Scalars['Int']['output'];
  totalCommentsCount: Scalars['Int']['output'];
};

export type CustomerEmailsViewModel = {
  __typename?: 'CustomerEmailsViewModel';
  customerId: Scalars['Int']['output'];
  otherEmails: Array<Scalars['String']['output']>;
  personalEmails: Array<Scalars['String']['output']>;
  preferredEmail?: Maybe<Scalars['String']['output']>;
  workEmails: Array<Scalars['String']['output']>;
};

export type CustomerExtensions = {
  __typename?: 'CustomerExtensions';
  activeCustomersIds: Array<Scalars['Int']['output']>;
  myCustomer: MyCustomer;
  myCustomersBasicInfo: Array<CustomerViewModel>;
  myCustomersCountByFilter: Scalars['Int']['output'];
};


export type CustomerExtensionsMyCustomerArgs = {
  customerId: Scalars['Int']['input'];
};


export type CustomerExtensionsMyCustomersBasicInfoArgs = {
  input: GetMyCustomersBasicInfoInput;
};


export type CustomerExtensionsMyCustomersCountByFilterArgs = {
  input: GetMyCustomersCountByFilterInput;
};

export type CustomerListingActivitiesStatsViewModel = {
  __typename?: 'CustomerListingActivitiesStatsViewModel';
  customerId: Scalars['Int']['output'];
  dislikedCount: Scalars['Int']['output'];
  emailedCount: Scalars['Int']['output'];
  likedCount: Scalars['Int']['output'];
  pickCount: Scalars['Int']['output'];
  viewedCount: Scalars['Int']['output'];
};

export type CustomerSettings = {
  __typename?: 'CustomerSettings';
  emailAlerts: EmailAlerts;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  permissionSettings: PermissionSettings;
};

export enum CustomerSharingOptions {
  EquallyOwn = 'EQUALLY_OWN',
  Owner = 'OWNER',
  ViewAndEdit = 'VIEW_AND_EDIT',
  ViewOnly = 'VIEW_ONLY'
}

export type CustomerStats = {
  __typename?: 'CustomerStats';
  collaboration?: Maybe<CustomerCollaborationStatsViewModel>;
  customerId: Scalars['Int']['output'];
  listingActivities?: Maybe<CustomerListingActivitiesStatsViewModel>;
};

export type CustomerViewModel = {
  __typename?: 'CustomerViewModel';
  collaboration?: Maybe<CollaborationViewModel>;
  customerId: Scalars['Int']['output'];
  emails?: Maybe<CustomerEmailsViewModel>;
  firstName: Scalars['String']['output'];
  formattedAttributes?: Maybe<CustomerAttributesData>;
  isDeleted: Scalars['Boolean']['output'];
  lastName: Scalars['String']['output'];
  rawAttributes?: Maybe<Array<PersonAttributeText>>;
  sharingTypeId: CustomerSharingOptions;
  stats: CustomerStats;
  status: PersonStatus;
};

export enum CustomersFilter {
  Active = 'ACTIVE',
  All = 'ALL',
  Deleted = 'DELETED',
  HotProspects = 'HOT_PROSPECTS',
  Inactive = 'INACTIVE',
  Shared = 'SHARED',
  UsingCollaborationPortal = 'USING_COLLABORATION_PORTAL',
  WithAppointments = 'WITH_APPOINTMENTS',
  WithComments = 'WITH_COMMENTS',
  WithNewMatches = 'WITH_NEW_MATCHES'
}

export enum CustomersSortingColumn {
  Birthday = 'BIRTHDAY',
  Collaboration = 'COLLABORATION',
  DateCreated = 'DATE_CREATED',
  DateUpdated = 'DATE_UPDATED',
  Email = 'EMAIL',
  Facebook = 'FACEBOOK',
  FirstGivenName = 'FIRST_GIVEN_NAME',
  Instagram = 'INSTAGRAM',
  LinkedIn = 'LINKED_IN',
  Nickname = 'NICKNAME',
  Nm = 'NM',
  PhoneNumber = 'PHONE_NUMBER',
  Relationship = 'RELATIONSHIP',
  SecondGivenName = 'SECOND_GIVEN_NAME',
  Shared = 'SHARED',
  Status = 'STATUS',
  Title = 'TITLE',
  Twitter = 'TWITTER',
  Url = 'URL'
}

export type DateRangeCriteria = {
  __typename?: 'DateRangeCriteria';
  from?: Maybe<Scalars['DateTime']['output']>;
  to?: Maybe<Scalars['DateTime']['output']>;
};

export type DateRangeCriteriaInput = {
  from?: InputMaybe<Scalars['DateTime']['input']>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DateRangeInput = {
  endDate: Scalars['DateTime']['input'];
  startDate: Scalars['DateTime']['input'];
};

export type DealAgentCriteria = {
  __typename?: 'DealAgentCriteria';
  buyerAgent?: Maybe<Scalars['Boolean']['output']>;
  sellerAgent?: Maybe<Scalars['Boolean']['output']>;
};

export type DealAgentCriteriaInput = {
  buyerAgent?: InputMaybe<Scalars['Boolean']['input']>;
  sellerAgent?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DeleteNewMatchesInput = {
  customerId?: InputMaybe<Scalars['Int']['input']>;
  listingsIds: Array<Scalars['Int']['input']>;
};

export type EditCustomerInput = {
  addressDetails: Array<AddressPersonInfoInput>;
  agentNewMatchSettings?: InputMaybe<Array<Scalars['Int']['input']>>;
  customerId: Scalars['Int']['input'];
  customerNewMatchSettings?: InputMaybe<Array<Scalars['Int']['input']>>;
  email: Array<EmailPersonInfoInput>;
  firstName: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
  lastName: Scalars['String']['input'];
  oldProfileImageUrl?: InputMaybe<Scalars['String']['input']>;
  otherInfo: Array<PersonAttributeTextInput>;
  phone: Array<PhonePersonInfoInput>;
  profileImage?: InputMaybe<RpFileInput>;
  sharedNewMatchSettings?: InputMaybe<Array<Scalars['Int']['input']>>;
  showWarnOnCloseSettings: Scalars['Boolean']['input'];
};

export enum EmailAlertTimeOption {
  Daily = 'DAILY',
  Disabled = 'DISABLED',
  RealTime = 'REAL_TIME'
}

export type EmailAlerts = {
  __typename?: 'EmailAlerts';
  activityChange: EmailAlertTimeOption;
  appointmentConfirm: EmailAlertTimeOption;
  appointmentDecline: EmailAlertTimeOption;
  appointmentRequest: EmailAlertTimeOption;
  comment: EmailAlertTimeOption;
  newListing: EmailAlertTimeOption;
  removeListing: EmailAlertTimeOption;
};

export type EmailPersonInfo = {
  __typename?: 'EmailPersonInfo';
  emailText: Scalars['String']['output'];
  emailType: EmailType;
  isCarbonCopy: Scalars['Boolean']['output'];
  isPreferred: Scalars['Boolean']['output'];
};

export type EmailPersonInfoInput = {
  emailText: Scalars['String']['input'];
  emailType: EmailType;
  isCarbonCopy: Scalars['Boolean']['input'];
  isPreferred: Scalars['Boolean']['input'];
};

export enum EmailType {
  Office = 'OFFICE',
  Other = 'OTHER',
  Personal = 'PERSONAL'
}

export enum EventAction {
  AppointmentAccepted = 'APPOINTMENT_ACCEPTED',
  AppointmentCreated = 'APPOINTMENT_CREATED',
  AppointmentDeclined = 'APPOINTMENT_DECLINED',
  AppointmentDeleted = 'APPOINTMENT_DELETED',
  AppointmentUpdated = 'APPOINTMENT_UPDATED',
  CommentCreated = 'COMMENT_CREATED',
  CommentUpdated = 'COMMENT_UPDATED',
  ExternalListingAdded = 'EXTERNAL_LISTING_ADDED',
  FolderAdded = 'FOLDER_ADDED',
  FolderListingsChanged = 'FOLDER_LISTINGS_CHANGED',
  FolderRemoved = 'FOLDER_REMOVED',
  FolderUpdated = 'FOLDER_UPDATED',
  ListingActivityAddedToPortfolio = 'LISTING_ACTIVITY_ADDED_TO_PORTFOLIO',
  ListingActivityDisliked = 'LISTING_ACTIVITY_DISLIKED',
  ListingActivityLiked = 'LISTING_ACTIVITY_LIKED',
  ListingActivityRemoved = 'LISTING_ACTIVITY_REMOVED',
  ListingActivityShown = 'LISTING_ACTIVITY_SHOWN',
  ListingHardDeleted = 'LISTING_HARD_DELETED',
  ListingRestored = 'LISTING_RESTORED',
  ListingSoftDeleted = 'LISTING_SOFT_DELETED',
  NewMatchAdded = 'NEW_MATCH_ADDED'
}

export type EventsMutations = {
  __typename?: 'EventsMutations';
  appointmentAccepted: AcknowledgeId;
  appointmentCreated: AcknowledgeId;
  appointmentDeclined: AcknowledgeId;
  appointmentDeleted: AcknowledgeId;
  appointmentUpdated: AcknowledgeId;
  changedListingActivity: AcknowledgeId;
  commentCreated: AcknowledgeId;
  commentUpdated: AcknowledgeId;
  externalListingAdded: AcknowledgeId;
  folderAdded: AcknowledgeId;
  folderListingsChanged: AcknowledgeId;
  folderRemoved: AcknowledgeId;
  folderUpdated: AcknowledgeId;
  listingHardDeleted: AcknowledgeId;
  listingRestored: AcknowledgeId;
  listingSoftDeleted: AcknowledgeId;
  newListingActivity: AcknowledgeId;
  removeListingActivity: AcknowledgeId;
  userDeactivated: Acknowledge;
};


export type EventsMutationsAppointmentAcceptedArgs = {
  input: AppointmentEventInput;
};


export type EventsMutationsAppointmentCreatedArgs = {
  input: AppointmentEventInput;
};


export type EventsMutationsAppointmentDeclinedArgs = {
  input: AppointmentEventInput;
};


export type EventsMutationsAppointmentDeletedArgs = {
  input: AppointmentDeletedEventInput;
};


export type EventsMutationsAppointmentUpdatedArgs = {
  input: AppointmentUpdatedEventInput;
};


export type EventsMutationsChangedListingActivityArgs = {
  input: ListingActivityInput;
};


export type EventsMutationsCommentCreatedArgs = {
  input: CommentCreatedInput;
};


export type EventsMutationsCommentUpdatedArgs = {
  input: CommentUpdatedInput;
};


export type EventsMutationsExternalListingAddedArgs = {
  input: ExternalListingEventInput;
};


export type EventsMutationsFolderAddedArgs = {
  input: FolderEventInput;
};


export type EventsMutationsFolderListingsChangedArgs = {
  input: FolderEventInput;
};


export type EventsMutationsFolderRemovedArgs = {
  input: FolderEventInput;
};


export type EventsMutationsFolderUpdatedArgs = {
  input: FolderEventInput;
};


export type EventsMutationsListingHardDeletedArgs = {
  input: ListingsEventInput;
};


export type EventsMutationsListingRestoredArgs = {
  input: ListingsEventInput;
};


export type EventsMutationsListingSoftDeletedArgs = {
  input: ListingsEventInput;
};


export type EventsMutationsNewListingActivityArgs = {
  input: ListingActivityInput;
};


export type EventsMutationsRemoveListingActivityArgs = {
  input: NotificationsGraphQl_RemoveListingActivityInput;
};


export type EventsMutationsUserDeactivatedArgs = {
  userId: Scalars['Int']['input'];
};

export enum Exposure {
  East = 'EAST',
  North = 'NORTH',
  NorthEast = 'NORTH_EAST',
  NorthWest = 'NORTH_WEST',
  South = 'SOUTH',
  SouthEast = 'SOUTH_EAST',
  SouthWest = 'SOUTH_WEST',
  West = 'WEST'
}

export type ExternalListingEventInput = {
  collaborationId: Scalars['Int']['input'];
  createId: Scalars['Int']['input'];
  externalListingId: Scalars['Int']['input'];
};

export enum FeatureDetails {
  ExposedBrick = 'EXPOSED_BRICK',
  No = 'NO',
  Original = 'ORIGINAL',
  PreWarCharm = 'PRE_WAR_CHARM'
}

export type FloorsCriteria = {
  __typename?: 'FloorsCriteria';
  includePenthouses: Scalars['Boolean']['output'];
  minMax?: Maybe<MinMaxCriteria>;
};

export type FloorsCriteriaInput = {
  includePenthouses: Scalars['Boolean']['input'];
  minMax?: InputMaybe<MinMaxCriteriaInput>;
};

export type Folder = {
  __typename?: 'Folder';
  folderId: Scalars['Int']['output'];
  folderName: Scalars['String']['output'];
};

export type FolderBasicInfo = {
  __typename?: 'FolderBasicInfo';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type FolderDetails = {
  __typename?: 'FolderDetails';
  attachedSavedSearches: Array<AttachedSavedSearch>;
  createDate: Scalars['DateTime']['output'];
  createId: Scalars['Int']['output'];
  creatorFullName: Scalars['String']['output'];
  creatorProfileImageUrl?: Maybe<Scalars['String']['output']>;
  folderId: Scalars['Int']['output'];
  folderName: Scalars['String']['output'];
};

export type FolderEventInput = {
  collaborationId: Scalars['Int']['input'];
  createId: Scalars['Int']['input'];
  folderId: Scalars['Int']['input'];
};

export type FolderExtensions = {
  __typename?: 'FolderExtensions';
  customFolders: Array<CustomFolder>;
  customFoldersCount: Scalars['Int']['output'];
  folderDetails?: Maybe<FolderDetails>;
  folderListingsIds: Array<Scalars['Int']['output']>;
  folderListingsIdsPage: Array<Scalars['Int']['output']>;
  foldersList: Array<FolderBasicInfo>;
  listingsFolders: Array<ListingFolders>;
  listingsFoldersSelections: Array<FolderSelection>;
  savedSearchFoldersSelections: Array<FolderSelection>;
  systemFoldersListingsCount: SystemFoldersListingsCount;
};


export type FolderExtensionsCustomFoldersArgs = {
  input: GetCustomFoldersInput;
};


export type FolderExtensionsCustomFoldersCountArgs = {
  input: GetCustomFoldersCountInput;
};


export type FolderExtensionsFolderDetailsArgs = {
  input: GetFolderDetailsInput;
};


export type FolderExtensionsFolderListingsIdsArgs = {
  input: GetFolderListingsIdsInput;
};


export type FolderExtensionsFolderListingsIdsPageArgs = {
  input: GetFolderListingsInput;
};


export type FolderExtensionsFoldersListArgs = {
  input: GetFoldersListInput;
};


export type FolderExtensionsListingsFoldersArgs = {
  input: GetListingsFoldersInput;
};


export type FolderExtensionsListingsFoldersSelectionsArgs = {
  input: GetListingsFoldersSelectionsInput;
};


export type FolderExtensionsSavedSearchFoldersSelectionsArgs = {
  input: GetSavedSearchFoldersSelectionsInput;
};


export type FolderExtensionsSystemFoldersListingsCountArgs = {
  input: GetSystemFoldersListingsCountInput;
};

export type FolderListingsAttachmentManageInput = {
  foldersIds: Array<Scalars['Int']['input']>;
  listingsIds: Array<Scalars['Int']['input']>;
};

export type FolderSavedSearchesAttachmentManageInput = {
  foldersIds: Array<Scalars['Int']['input']>;
  savedSearchId: Scalars['Int']['input'];
};

export type FolderSelection = {
  __typename?: 'FolderSelection';
  folderId: Scalars['Int']['output'];
  folderName: Scalars['String']['output'];
  selected: Scalars['Boolean']['output'];
};

export enum FoldersSortingField {
  Alphabetical = 'ALPHABETICAL',
  DateCreated = 'DATE_CREATED'
}

export type FreeRent = {
  __typename?: 'FreeRent';
  andOr?: Maybe<ValueOfAndOr>;
  description?: Maybe<Scalars['String']['output']>;
  expirationDate?: Maybe<Scalars['DateTime']['output']>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  value?: Maybe<ValueOfYesNoUnknown>;
};

export type GeoInfo = {
  __typename?: 'GeoInfo';
  lat: Scalars['Float']['output'];
  listingId: Scalars['Int']['output'];
  lon: Scalars['Float']['output'];
  price?: Maybe<Scalars['Float']['output']>;
};

export type GetAgentOpenHousesInput = {
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
};

export type GetCollaborationAppointmentsInput = {
  customerIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  dateRange?: InputMaybe<DateRangeInput>;
  listingsIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};

export type GetCustomFoldersCountInput = {
  customerId?: InputMaybe<Scalars['Int']['input']>;
  folderNameFilter?: InputMaybe<Scalars['String']['input']>;
};

export type GetCustomFoldersInput = {
  customerId?: InputMaybe<Scalars['Int']['input']>;
  folderNameFilter?: InputMaybe<Scalars['String']['input']>;
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
};

export type GetCustomerOpenHousesInput = {
  customerId: Scalars['Int']['input'];
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
};

export type GetFolderDetailsInput = {
  customerId?: InputMaybe<Scalars['Int']['input']>;
  folderId: Scalars['Int']['input'];
};

export type GetFolderListingsIdsInput = {
  customerId?: InputMaybe<Scalars['Int']['input']>;
  folderId: Scalars['Int']['input'];
  listingCategory?: InputMaybe<ListingCategoryType>;
};

export type GetFolderListingsInput = {
  beds?: InputMaybe<MinMaxInput>;
  customerId?: InputMaybe<Scalars['Int']['input']>;
  disliked: Scalars['Boolean']['input'];
  filterFolderId?: InputMaybe<Scalars['Int']['input']>;
  folderId: Scalars['Int']['input'];
  liked: Scalars['Boolean']['input'];
  listingCategory?: InputMaybe<ListingCategoryType>;
  listingsIdsFilter?: InputMaybe<Array<Scalars['Int']['input']>>;
  newMatch: Scalars['Boolean']['input'];
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  picked: Scalars['Boolean']['input'];
  price?: InputMaybe<MinMaxInput>;
  rooms?: InputMaybe<MinMaxInput>;
  shown: Scalars['Boolean']['input'];
  sortingDirection?: InputMaybe<SortingDirection>;
  sortingField?: InputMaybe<ListingsSortingField>;
  withAppointments: Scalars['Boolean']['input'];
  withComments: Scalars['Boolean']['input'];
};

export type GetFoldersListInput = {
  agentId: Scalars['Int']['input'];
  customerId?: InputMaybe<Scalars['Int']['input']>;
};

export type GetListingDialogCommentsInput = {
  customerCollaborationId: Scalars['Int']['input'];
  listingId: Scalars['Int']['input'];
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
};

export type GetListingDialogCommentsOutput = {
  __typename?: 'GetListingDialogCommentsOutput';
  comments: Array<ListingComment>;
};

export type GetListingDialogOutput = {
  __typename?: 'GetListingDialogOutput';
  dialogs: Array<ListingDialog>;
};

export type GetListingDialogsCountInput = {
  customerNameFilter?: InputMaybe<Scalars['String']['input']>;
  listingId: Scalars['Int']['input'];
};

export type GetListingDialogsInput = {
  customerNameFilter?: InputMaybe<Scalars['String']['input']>;
  listingId: Scalars['Int']['input'];
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
};

export type GetListingsFoldersInput = {
  customerId?: InputMaybe<Scalars['Int']['input']>;
  listingsIds: Array<Scalars['Int']['input']>;
};

export type GetListingsFoldersSelectionsInput = {
  customerId?: InputMaybe<Scalars['Int']['input']>;
  folderNameFilter?: InputMaybe<Scalars['String']['input']>;
  foldersSortingField?: InputMaybe<FoldersSortingField>;
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  selectedListingsIds: Array<Scalars['Int']['input']>;
  sortingDirection?: InputMaybe<SortingDirection>;
};

export type GetListingsIdsByCriteriaOutput = {
  __typename?: 'GetListingsIdsByCriteriaOutput';
  ids: Array<Scalars['Int']['output']>;
};

export type GetListingsSettingsInput = {
  isBuilding?: InputMaybe<Scalars['Boolean']['input']>;
  listingsIds: Array<Scalars['Int']['input']>;
};

export type GetMyCustomersBasicInfoInput = {
  filter: CustomersFilter;
  fullNamePattern?: InputMaybe<Scalars['String']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sorting?: InputMaybe<CustomersSortingColumn>;
};

export type GetMyCustomersCountByFilterInput = {
  filter: CustomersFilter;
  fullNamePattern?: InputMaybe<Scalars['String']['input']>;
};

export type GetNewMatchListingsIdsInput = {
  addressPart?: InputMaybe<Scalars['String']['input']>;
  customerId?: InputMaybe<Scalars['Int']['input']>;
  listingCategory?: InputMaybe<ListingCategoryType>;
  newMatchReason?: InputMaybe<NewMatchReason>;
};

export type GetNewMatchListingsInput = {
  addressPart?: InputMaybe<Scalars['String']['input']>;
  customerId?: InputMaybe<Scalars['Int']['input']>;
  listingCategory?: InputMaybe<ListingCategoryType>;
  newMatchReason?: InputMaybe<NewMatchReason>;
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  sorting?: InputMaybe<ListingsSortingField>;
  sortingDirection?: InputMaybe<SortingDirection>;
};

export type GetNewMatchesBasicInfoInput = {
  count: Scalars['Int']['input'];
  customerId?: InputMaybe<Scalars['Int']['input']>;
};

export type GetOpenHouseListingsIdsInput = {
  addressFilter?: InputMaybe<Scalars['String']['input']>;
  customerId?: InputMaybe<Scalars['Int']['input']>;
};

export type GetSavedSearchFoldersSelectionsInput = {
  customerId?: InputMaybe<Scalars['Int']['input']>;
  folderNameFilter?: InputMaybe<Scalars['String']['input']>;
  foldersSortingField?: InputMaybe<FoldersSortingField>;
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  savedSearchId?: InputMaybe<Scalars['Int']['input']>;
  sortingDirection?: InputMaybe<SortingDirection>;
};

export type GetSavedSearchesInput = {
  customerId?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
};

export type GetSearchHistoryInput = {
  lastSearchHistoryClearDate: Scalars['DateTime']['input'];
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  sortingDirection: SortingDirection;
};

export type GetSignificantChangesHistoryInput = {
  isFiltered: Scalars['Boolean']['input'];
  isUnit: Scalars['Boolean']['input'];
};

export type GetSystemFoldersListingsCountInput = {
  customerId?: InputMaybe<Scalars['Int']['input']>;
};

export type GetTop1CollaborationAppointmentsPerCustomerInput = {
  customerIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  listingsIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type HasMarketListingsInput = {
  customerId?: InputMaybe<Scalars['Int']['input']>;
  listingsIds: Array<Scalars['Int']['input']>;
};

export type HasNewMatchesInput = {
  customerId?: InputMaybe<Scalars['Int']['input']>;
  listingsIds: Array<Scalars['Int']['input']>;
};

export enum HealthclubType {
  FitnessRoom = 'FITNESS_ROOM',
  HealthClub = 'HEALTH_CLUB',
  No = 'NO',
  Unknown = 'UNKNOWN',
  Yes = 'YES'
}

export enum HeatingType {
  ConEdSteam = 'CON_ED_STEAM',
  Electric = 'ELECTRIC',
  Gas = 'GAS',
  Individual = 'INDIVIDUAL',
  Oil = 'OIL',
  Radiant = 'RADIANT',
  Steam = 'STEAM'
}

export type IdsCriteria = {
  __typename?: 'IdsCriteria';
  ids: Array<Scalars['Int']['output']>;
};

export type IdsCriteriaInput = {
  ids: Array<Scalars['Int']['input']>;
};

export enum InvitationStatus {
  Active = 'ACTIVE',
  Invited = 'INVITED',
  NotInvited = 'NOT_INVITED',
  Revoked = 'REVOKED'
}

export type InviteCustomerInput = {
  customerEmail: Scalars['String']['input'];
  customerId: Scalars['Int']['input'];
};

export type InviteCustomerOutput = {
  __typename?: 'InviteCustomerOutput';
  agentId: Scalars['Int']['output'];
  childCustomerId?: Maybe<Scalars['Int']['output']>;
  createdDate: Scalars['DateTime']['output'];
  customerCollaborationId: Scalars['Int']['output'];
  customerId: Scalars['Int']['output'];
  expirationDate?: Maybe<Scalars['DateTime']['output']>;
  expiresIn?: Maybe<Scalars['Int']['output']>;
  invitatingAgentId?: Maybe<Scalars['Int']['output']>;
  invitationEmail: Scalars['String']['output'];
  invitationMessage?: Maybe<Scalars['String']['output']>;
  invitationUrl?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
};

export type KeyValuePairOfInt32AndCollaborationAppointmentPreview = {
  __typename?: 'KeyValuePairOfInt32AndCollaborationAppointmentPreview';
  key: Scalars['Int']['output'];
  value: CollaborationAppointmentPreview;
};

export type KeyValuePairOfInt32AndGeoInfo__ = {
  __typename?: 'KeyValuePairOfInt32AndGeoInfo__';
  key: Scalars['Int']['output'];
  value: Array<GeoInfo>;
};

export type KeyValuePairOfInt32AndInt32 = {
  __typename?: 'KeyValuePairOfInt32AndInt32';
  key: Scalars['Int']['output'];
  value: Scalars['Int']['output'];
};

export type KeyValuePairOfInt32AndListingSearchViewModel = {
  __typename?: 'KeyValuePairOfInt32AndListingSearchViewModel';
  key: Scalars['Int']['output'];
  value: ListingSearchViewModel;
};

export type LastPriceChange = {
  __typename?: 'LastPriceChange';
  changeDate: Scalars['DateTime']['output'];
  changeDirection: Scalars['String']['output'];
  changePercent?: Maybe<Scalars['Float']['output']>;
};

export type LeaseTermsCriteria = {
  __typename?: 'LeaseTermsCriteria';
  minMax?: Maybe<MinMaxCriteria>;
  values?: Maybe<IdsCriteria>;
};

export type LeaseTermsCriteriaInput = {
  minMax?: InputMaybe<MinMaxCriteriaInput>;
  values?: InputMaybe<IdsCriteriaInput>;
};

export enum Light {
  Excellent = 'EXCELLENT',
  Fair = 'FAIR',
  Good = 'GOOD',
  No = 'NO',
  Poor = 'POOR',
  Yes = 'YES'
}

export type Listing = {
  __typename?: 'Listing';
  activityHistory: ListingActivityHistory;
  agentActivities?: Maybe<ListingActivitiesDetails>;
  agents: Array<ListingAgent>;
  attributes: ListingAttributes;
  buildingActivityListings: Array<ActivityUnitViewModel>;
  closingHistory: Array<ListingClosingHistory>;
  creditHistory: Array<ListingCredit>;
  customerActivities?: Maybe<ListingActivitiesDetails>;
  customersActivityHistory: Array<CustomerActivityHistory>;
  defaultMedia?: Maybe<Scalars['String']['output']>;
  details: ListingDetails;
  externalLinks: Array<ApartmentMediaExternalLinkViewModel>;
  id: Scalars['Int']['output'];
  lastPriceChange?: Maybe<ListingPriceChanged>;
  media?: Maybe<Media>;
  nearByTransportations?: Maybe<ListingNearByTransportations>;
  newMatches?: Maybe<Array<ListingNewMatch>>;
  notes?: Maybe<Array<ListingNote>>;
  openHouseHistory: Array<ListingOpenHouseHistory>;
  openHouses: Array<ListingOpenHouse>;
  priceChangeHistory: Array<ListingPriceChanged>;
  significantChangesHistory: Array<ListingChangesValue>;
  stats: ListingStats;
};


export type ListingActivityHistoryArgs = {
  customerId?: InputMaybe<Scalars['Int']['input']>;
};


export type ListingBuildingActivityListingsArgs = {
  buildingActivity: BuildingActivity;
};


export type ListingCustomerActivitiesArgs = {
  customerId: Scalars['Int']['input'];
};


export type ListingDetailsArgs = {
  customerId?: InputMaybe<Scalars['Int']['input']>;
};


export type ListingNewMatchesArgs = {
  customerId?: InputMaybe<Scalars['Int']['input']>;
};


export type ListingNotesArgs = {
  customerId?: InputMaybe<Scalars['Int']['input']>;
};


export type ListingOpenHouseHistoryArgs = {
  isForPast: Scalars['Boolean']['input'];
};


export type ListingSignificantChangesHistoryArgs = {
  input: GetSignificantChangesHistoryInput;
};

export type ListingActivitiesDetails = {
  __typename?: 'ListingActivitiesDetails';
  dislikedDateTime?: Maybe<Scalars['DateTime']['output']>;
  emailedDateTime?: Maybe<Scalars['DateTime']['output']>;
  isDeleted: Scalars['Boolean']['output'];
  isDisliked: Scalars['Boolean']['output'];
  isEmailed: Scalars['Boolean']['output'];
  isLiked: Scalars['Boolean']['output'];
  isNewViewed: Scalars['Boolean']['output'];
  isPickListed: Scalars['Boolean']['output'];
  isShown: Scalars['Boolean']['output'];
  isUpdateViewed: Scalars['Boolean']['output'];
  likedDateTime?: Maybe<Scalars['DateTime']['output']>;
  pickListedDateTime?: Maybe<Scalars['DateTime']['output']>;
  shownDateTime?: Maybe<Scalars['DateTime']['output']>;
};

export enum ListingActivityAction {
  Disliked = 'DISLIKED',
  Liked = 'LIKED',
  Picked = 'PICKED',
  Removed = 'REMOVED',
  Shown = 'SHOWN'
}

export type ListingActivityHistory = {
  __typename?: 'ListingActivityHistory';
  activities: Array<ListingActivityInfo>;
  createDateTime: Scalars['DateTime']['output'];
  createInitiatorFirstName?: Maybe<Scalars['String']['output']>;
  createInitiatorLastName?: Maybe<Scalars['String']['output']>;
  createInitiatorProfileImage?: Maybe<Scalars['String']['output']>;
  emailedActivity?: Maybe<ListingActivityInfo>;
  softDeleted: Scalars['Boolean']['output'];
  softDeletedDate?: Maybe<Scalars['DateTime']['output']>;
};

export type ListingActivityInfo = {
  __typename?: 'ListingActivityInfo';
  action: ActivityAction;
  date: Scalars['DateTime']['output'];
  initiatorFirstName?: Maybe<Scalars['String']['output']>;
  initiatorId?: Maybe<Scalars['Int']['output']>;
  initiatorLastName?: Maybe<Scalars['String']['output']>;
  initiatorProfileImage?: Maybe<Scalars['String']['output']>;
};

export type ListingActivityInput = {
  action: ListingActivityAction;
  agentListingPinIds: Array<Scalars['Int']['input']>;
  collaborationId: Scalars['Int']['input'];
  date: Scalars['DateTime']['input'];
};

export type ListingAgent = {
  __typename?: 'ListingAgent';
  cellPhone?: Maybe<Scalars['String']['output']>;
  cityTown?: Maybe<Scalars['String']['output']>;
  commissionPercent?: Maybe<Scalars['String']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  contactType?: Maybe<Scalars['String']['output']>;
  emailAddress?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  fullPhoneNumber?: Maybe<Scalars['String']['output']>;
  line1?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  stateProvince?: Maybe<Scalars['String']['output']>;
  toShow?: Maybe<Scalars['String']['output']>;
};

export type ListingAttributes = {
  __typename?: 'ListingAttributes';
  accessInstructions?: Maybe<Scalars['String']['output']>;
  additionalFeatures?: Maybe<Scalars['String']['output']>;
  address?: Maybe<Scalars['String']['output']>;
  affectedByPandemic2020: Scalars['Boolean']['output'];
  airConditioning?: Maybe<Array<ValueOfAirConditioningType>>;
  apartmentStorage?: Maybe<Array<ValueOfStorageType>>;
  applianceCondition?: Maybe<Scalars['String']['output']>;
  approxExteriorSqFt?: Maybe<Scalars['Float']['output']>;
  attendedLobby?: Maybe<Array<Value>>;
  availableAirRights?: Maybe<Scalars['String']['output']>;
  availableForOccupancyDate?: Maybe<Scalars['DateTime']['output']>;
  availableForShowingDate?: Maybe<Scalars['DateTime']['output']>;
  bathroomCondition?: Maybe<Scalars['String']['output']>;
  baths?: Maybe<Scalars['Float']['output']>;
  beds?: Maybe<Scalars['Float']['output']>;
  bonusOffered?: Maybe<BonusOffered>;
  brokerToBrokerComment?: Maybe<Scalars['String']['output']>;
  buildingAllowed?: Maybe<Scalars['String']['output']>;
  buildingAmenities?: Maybe<Array<Value>>;
  buildingDescription?: Maybe<Scalars['String']['output']>;
  buildingInformationLastUpdated?: Maybe<Scalars['String']['output']>;
  buildingName?: Maybe<Scalars['String']['output']>;
  buildingPeriod?: Maybe<Value>;
  buildingStorage?: Maybe<Array<ValueOfBuildingStorageType>>;
  buildingStyle?: Maybe<Value>;
  buyerCommision: Scalars['Decimal']['output'];
  ceilingHeight?: Maybe<Scalars['String']['output']>;
  ceilings?: Maybe<Scalars['String']['output']>;
  closingDate?: Maybe<Scalars['DateTime']['output']>;
  coBrokeAgreement?: Maybe<Scalars['String']['output']>;
  collectYourOwnFee?: Maybe<ValueOfYesNoUnknown>;
  commissionRemarks?: Maybe<Scalars['String']['output']>;
  commonOutdoorSpace?: Maybe<Array<Value>>;
  condition?: Maybe<Scalars['String']['output']>;
  crossStreets?: Maybe<Scalars['String']['output']>;
  daysOnQuarantine?: Maybe<Scalars['Int']['output']>;
  dealRequirements?: Maybe<Scalars['String']['output']>;
  decorativeFireplaces: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  dom?: Maybe<Scalars['Int']['output']>;
  doorman?: Maybe<Scalars['String']['output']>;
  doormanRemarks?: Maybe<Scalars['String']['output']>;
  elevators?: Maybe<Scalars['Int']['output']>;
  exposures?: Maybe<Array<ValueOfExposure>>;
  featureDetails?: Maybe<Array<ValueOfFeatureDetails>>;
  financeAllowedPercent?: Maybe<Scalars['Float']['output']>;
  fireplaces: Scalars['Int']['output'];
  flipTaxPaidBy?: Maybe<Scalars['String']['output']>;
  flooring?: Maybe<Scalars['String']['output']>;
  freeRent?: Maybe<FreeRent>;
  freshAirSystem?: Maybe<Scalars['String']['output']>;
  fullAddress?: Maybe<Scalars['String']['output']>;
  fullStreetName?: Maybe<Scalars['String']['output']>;
  furnishedRent?: Maybe<Scalars['Decimal']['output']>;
  gasFireplaces: Scalars['Int']['output'];
  hasWasherDryer: Scalars['Boolean']['output'];
  healthclub?: Maybe<ValueOfHealthclubType>;
  heat?: Maybe<Array<ValueOfHeatingType>>;
  hvac?: Maybe<Scalars['String']['output']>;
  isExclusive?: Maybe<Scalars['Boolean']['output']>;
  isFurnished?: Maybe<ValueOfYesNoUnknown>;
  isNewListing?: Maybe<Scalars['Boolean']['output']>;
  kitchenCondition?: Maybe<Scalars['String']['output']>;
  landLease?: Maybe<Scalars['String']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  laundry?: Maybe<Scalars['String']['output']>;
  leaseTerm?: Maybe<Scalars['String']['output']>;
  leaseType?: Maybe<Scalars['String']['output']>;
  light?: Maybe<Array<ValueOfLight>>;
  listDate?: Maybe<Scalars['DateTime']['output']>;
  listingCategory?: Maybe<Scalars['String']['output']>;
  listingCompany?: Maybe<Scalars['String']['output']>;
  listingCurrentPrice?: Maybe<Scalars['Decimal']['output']>;
  listingCurrentStatus?: Maybe<Scalars['String']['output']>;
  listingDescription?: Maybe<Scalars['String']['output']>;
  listingInitialPrice?: Maybe<Scalars['Decimal']['output']>;
  listingMediaXML?: Maybe<Scalars['String']['output']>;
  listingNumber?: Maybe<Scalars['String']['output']>;
  listingType?: Maybe<Scalars['String']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  maintanance?: Maybe<Scalars['Decimal']['output']>;
  neighborhood?: Maybe<Scalars['String']['output']>;
  neighborhoodId?: Maybe<Scalars['String']['output']>;
  outdoorSpace?: Maybe<Scalars['String']['output']>;
  ownerPays?: Maybe<OwnerPays>;
  ownershipType?: Maybe<Scalars['String']['output']>;
  parking?: Maybe<ValueOfYesNoUnknown>;
  parkingDetails?: Maybe<Scalars['String']['output']>;
  parkingSpots?: Maybe<Scalars['String']['output']>;
  petPolicy?: Maybe<Scalars['String']['output']>;
  petRestrictions?: Maybe<Scalars['String']['output']>;
  petsAllowed?: Maybe<ValueOfYesNoUnknown>;
  poolDetails?: Maybe<Scalars['String']['output']>;
  poolSize?: Maybe<Scalars['String']['output']>;
  pricePerSqft?: Maybe<Scalars['Decimal']['output']>;
  privateOutdoorSpace?: Maybe<Array<ValueOfPrivateOutdoorSpace>>;
  property: ListingPropertyAttributes;
  propertyAirConditioning?: Maybe<ValueOfAirConditioningType>;
  propertyId?: Maybe<Scalars['String']['output']>;
  reTaxes?: Maybe<Scalars['Float']['output']>;
  rentedDate?: Maybe<Scalars['DateTime']['output']>;
  rooms?: Maybe<Scalars['Float']['output']>;
  security?: Maybe<Scalars['String']['output']>;
  sellerCommision: Scalars['Decimal']['output'];
  shares?: Maybe<Scalars['Int']['output']>;
  showingInstructions?: Maybe<Scalars['String']['output']>;
  signedDate?: Maybe<Scalars['DateTime']['output']>;
  soldPrice?: Maybe<Scalars['Decimal']['output']>;
  squareFootage?: Maybe<Scalars['Float']['output']>;
  storage?: Maybe<Scalars['String']['output']>;
  superRemarks?: Maybe<Scalars['String']['output']>;
  taxDeductPercent?: Maybe<Scalars['Decimal']['output']>;
  totalCommission?: Maybe<Scalars['String']['output']>;
  totalFloors?: Maybe<Scalars['Int']['output']>;
  totalPetsAllowed?: Maybe<Scalars['Int']['output']>;
  townhouse: TownhouseAttributes;
  townhouseType?: Maybe<Scalars['String']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
  unitCondition?: Maybe<Scalars['String']['output']>;
  updatedDate?: Maybe<Scalars['DateTime']['output']>;
  verifiedDate?: Maybe<Scalars['DateTime']['output']>;
  views?: Maybe<Array<ValueOfView>>;
  washerDryer?: Maybe<Array<ValueOfWasherDryer>>;
  washerDryerType?: Maybe<Scalars['String']['output']>;
  webId?: Maybe<Scalars['String']['output']>;
  windows?: Maybe<Scalars['String']['output']>;
  woodBurningFireplaces: Scalars['Int']['output'];
  yearBuilt?: Maybe<Scalars['Int']['output']>;
  zipCode?: Maybe<Scalars['Long']['output']>;
  zoning?: Maybe<Scalars['String']['output']>;
};

export type ListingBasicInfo = {
  __typename?: 'ListingBasicInfo';
  bathrooms?: Maybe<Scalars['Float']['output']>;
  bedrooms?: Maybe<Scalars['Float']['output']>;
  buildingPeriod?: Maybe<Scalars['String']['output']>;
  disliked: Scalars['Boolean']['output'];
  feePaidBy?: Maybe<Scalars['String']['output']>;
  fullAddress?: Maybe<Scalars['String']['output']>;
  liked: Scalars['Boolean']['output'];
  listingAddress: Scalars['String']['output'];
  listingCategoryId: Scalars['Int']['output'];
  listingId: Scalars['Int']['output'];
  listingUnit: Scalars['String']['output'];
  media?: Maybe<Media>;
  neighborhood?: Maybe<Scalars['String']['output']>;
  openHouses: Scalars['Int']['output'];
  pickListed: Scalars['Boolean']['output'];
  price?: Maybe<Scalars['Decimal']['output']>;
  pricePerSqFt?: Maybe<Scalars['Float']['output']>;
  sqFt?: Maybe<Scalars['Int']['output']>;
  visited: Scalars['Boolean']['output'];
};

export enum ListingCategoryType {
  Rentals = 'RENTALS',
  Sales = 'SALES'
}

export type ListingChangesValue = {
  __typename?: 'ListingChangesValue';
  agentName?: Maybe<Scalars['String']['output']>;
  approvedBy?: Maybe<Scalars['String']['output']>;
  changeDate?: Maybe<Scalars['String']['output']>;
  changeStatus?: Maybe<Scalars['String']['output']>;
  changeTime?: Maybe<Scalars['String']['output']>;
  comments?: Maybe<Scalars['String']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  contactNumber?: Maybe<Scalars['String']['output']>;
  dep?: Maybe<Scalars['String']['output']>;
  listingId: Scalars['Int']['output'];
  listingNumber?: Maybe<Scalars['String']['output']>;
  listingType?: Maybe<Scalars['String']['output']>;
  monthly?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['String']['output']>;
  subStatus?: Maybe<Scalars['String']['output']>;
  totalCommission?: Maybe<Scalars['String']['output']>;
  transactionDateTime?: Maybe<Scalars['DateTime']['output']>;
};

export type ListingClosingHistory = {
  __typename?: 'ListingClosingHistory';
  currentPrice?: Maybe<Scalars['Decimal']['output']>;
  currentStatus: Scalars['String']['output'];
  dom?: Maybe<Scalars['String']['output']>;
  listingCategory: ListingCategoryType;
  listingId: Scalars['Int']['output'];
  parentListingId: Scalars['Int']['output'];
  updateDateTime?: Maybe<Scalars['DateTime']['output']>;
};

export type ListingClustersByIdsInput = {
  center: MapCoordinateInput;
  distanceInMeters: Scalars['Float']['input'];
  listingsIds: Array<Scalars['Int']['input']>;
};

export type ListingClustersInput = {
  center: MapCoordinateInput;
  criteria: SearchCriteriaInput;
  distanceInMeters: Scalars['Float']['input'];
  listingsIdsFilter?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type ListingClustersOutput = {
  __typename?: 'ListingClustersOutput';
  clusters: Array<ClusterItem>;
};

export type ListingCollaborationStatsViewModel = {
  __typename?: 'ListingCollaborationStatsViewModel';
  customerId: Scalars['Int']['output'];
  latestAppointmentDate?: Maybe<Scalars['DateTime']['output']>;
  latestCommentDate?: Maybe<Scalars['DateTime']['output']>;
  listingId: Scalars['Int']['output'];
  newAppointmentsCount: Scalars['Int']['output'];
  newCommentsCount: Scalars['Int']['output'];
  totalAppointmentsCount: Scalars['Int']['output'];
  totalCommentsCount: Scalars['Int']['output'];
};

export type ListingComment = {
  __typename?: 'ListingComment';
  comment: Scalars['String']['output'];
  createId: Scalars['Int']['output'];
  creatorFirstName: Scalars['String']['output'];
  creatorFullName: Scalars['String']['output'];
  creatorLastName: Scalars['String']['output'];
  creatorProfileImageUrl?: Maybe<Scalars['String']['output']>;
  customerCollaborationId: Scalars['Int']['output'];
  dateCreated: Scalars['DateTime']['output'];
  dateUpdated?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  listingId: Scalars['Int']['output'];
  updateId?: Maybe<Scalars['Int']['output']>;
  viewed: Scalars['Boolean']['output'];
};

export type ListingCompany = {
  __typename?: 'ListingCompany';
  name: Scalars['String']['output'];
};

export type ListingCredit = {
  __typename?: 'ListingCredit';
  agentFullName: Scalars['String']['output'];
  agentId?: Maybe<Scalars['Int']['output']>;
  commissionPercent?: Maybe<Scalars['Decimal']['output']>;
  company: Scalars['String']['output'];
  companyName: Scalars['String']['output'];
  dateAct?: Maybe<Scalars['String']['output']>;
  dep?: Maybe<Scalars['Int']['output']>;
  email: Scalars['String']['output'];
  enteredDate?: Maybe<Scalars['DateTime']['output']>;
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  listingCreditType: Scalars['String']['output'];
  listingId: Scalars['Int']['output'];
  secureGroup: Scalars['String']['output'];
  timeAct?: Maybe<Scalars['String']['output']>;
};

export type ListingDetails = {
  __typename?: 'ListingDetails';
  address: Scalars['String']['output'];
  baths: Scalars['Float']['output'];
  beds: Scalars['Float']['output'];
  coExclusiveCompanies: Array<Scalars['String']['output']>;
  displayAddress: Scalars['String']['output'];
  isCoExclusive: Scalars['Boolean']['output'];
  isOpenRental: Scalars['Boolean']['output'];
  listingCategory: ValueOfListingCategoryType;
  listingId: Scalars['Int']['output'];
  listingType?: Maybe<ValueOfListingType>;
  neighborhood: Scalars['String']['output'];
  price: Scalars['Float']['output'];
  secureGroup: Scalars['String']['output'];
  unit: Scalars['String']['output'];
};

export type ListingDialog = {
  __typename?: 'ListingDialog';
  lastComment: ListingComment;
  newCommentsCount: Scalars['Int']['output'];
  primaryCustomerFullName: Scalars['String']['output'];
  primaryCustomerId: Scalars['Int']['output'];
  primaryCustomerProfileImageUrl?: Maybe<Scalars['String']['output']>;
};

export type ListingFolderInfo = {
  __typename?: 'ListingFolderInfo';
  dateAdded: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  newMatchId?: Maybe<Scalars['Int']['output']>;
};

export type ListingFolders = {
  __typename?: 'ListingFolders';
  folders: Array<ListingFolderInfo>;
  listingId: Scalars['Int']['output'];
};

export type ListingNearByLine = {
  __typename?: 'ListingNearByLine';
  color: Scalars['String']['output'];
  lineName: Scalars['String']['output'];
  shapeType: Scalars['String']['output'];
};

export type ListingNearByStation = {
  __typename?: 'ListingNearByStation';
  distance: Scalars['String']['output'];
  duration: Scalars['String']['output'];
  lines: Array<ListingNearByLine>;
  name: Scalars['String']['output'];
};

export type ListingNearByTransportations = {
  __typename?: 'ListingNearByTransportations';
  stations: Array<ListingNearByStation>;
  title: Scalars['String']['output'];
};

export type ListingNewMatch = {
  __typename?: 'ListingNewMatch';
  folderId?: Maybe<Scalars['Int']['output']>;
  folderName?: Maybe<Scalars['String']['output']>;
  newMatchCreateDate?: Maybe<Scalars['DateTime']['output']>;
  newMatchReason?: Maybe<Scalars['String']['output']>;
  newMatchRecordId: Scalars['Int']['output'];
  newMatchUpdateDate?: Maybe<Scalars['DateTime']['output']>;
  savedSearchCreateId: Scalars['Int']['output'];
  savedSearchCreatorFirstName: Scalars['String']['output'];
  savedSearchCreatorLastName: Scalars['String']['output'];
  savedSearchCreatorProfileImage?: Maybe<Scalars['String']['output']>;
  savedSearchId: Scalars['Int']['output'];
  savedSearchName: Scalars['String']['output'];
};

export type ListingNote = {
  __typename?: 'ListingNote';
  createDate?: Maybe<Scalars['DateTime']['output']>;
  createId?: Maybe<Scalars['Int']['output']>;
  creator?: Maybe<Person>;
  id: Scalars['Int']['output'];
  listingId: Scalars['Int']['output'];
  text: Scalars['String']['output'];
  type: ListingNoteType;
  updateDate?: Maybe<Scalars['DateTime']['output']>;
  updateId?: Maybe<Scalars['Int']['output']>;
  updater?: Maybe<Person>;
};

export enum ListingNoteType {
  Customer = 'CUSTOMER',
  InHouse = 'IN_HOUSE',
  Personal = 'PERSONAL',
  Unknown = 'UNKNOWN'
}

export type ListingOpenHouse = {
  __typename?: 'ListingOpenHouse';
  agent?: Maybe<Scalars['String']['output']>;
  appointmentOnly: Scalars['Boolean']['output'];
  comment?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['String']['output']>;
  endDateTime: Scalars['DateTime']['output'];
  listingOpenHouseID: Scalars['Int']['output'];
  newStartDate?: Maybe<Scalars['String']['output']>;
  newTime?: Maybe<Scalars['String']['output']>;
  officeCode?: Maybe<Scalars['String']['output']>;
  officeDetail?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['String']['output']>;
  startDateTime: Scalars['DateTime']['output'];
};

export type ListingOpenHouseHistory = {
  __typename?: 'ListingOpenHouseHistory';
  comment: Scalars['String']['output'];
  dateAct: Scalars['String']['output'];
  listingId: Scalars['Int']['output'];
  sortDate?: Maybe<Scalars['Int']['output']>;
  sortOH?: Maybe<Scalars['Int']['output']>;
  timeAct: Scalars['String']['output'];
};

export type ListingPriceChanged = {
  __typename?: 'ListingPriceChanged';
  delta?: Maybe<Scalars['Decimal']['output']>;
  increaseOrDrop: Scalars['String']['output'];
  listingId: Scalars['Int']['output'];
  listingPrice: Scalars['Decimal']['output'];
  listingPriceBefore?: Maybe<Scalars['Decimal']['output']>;
  percentChange?: Maybe<Scalars['Decimal']['output']>;
  priceDateTime: Scalars['DateTime']['output'];
};

export type ListingPropertyAttributes = {
  __typename?: 'ListingPropertyAttributes';
  buildingExtension?: Maybe<Scalars['String']['output']>;
  buildingSize?: Maybe<Scalars['String']['output']>;
  lotSize?: Maybe<Scalars['String']['output']>;
};

export type ListingSearchContactsViewModel = {
  __typename?: 'ListingSearchContactsViewModel';
  agentIds?: Maybe<Array<Scalars['Int']['output']>>;
  dealContactSecureGroups?: Maybe<Array<Scalars['String']['output']>>;
  emails?: Maybe<Array<Scalars['String']['output']>>;
  names?: Maybe<Array<Scalars['String']['output']>>;
  officeIds?: Maybe<Array<Scalars['Int']['output']>>;
  phones?: Maybe<Array<Scalars['String']['output']>>;
};

export type ListingSearchViewModel = {
  __typename?: 'ListingSearchViewModel';
  ac?: Maybe<Scalars['String']['output']>;
  accessInstructions?: Maybe<Scalars['String']['output']>;
  acrisId?: Maybe<Scalars['String']['output']>;
  acrisPropertyType?: Maybe<Scalars['String']['output']>;
  additionalPetPolicy?: Maybe<Scalars['String']['output']>;
  address?: Maybe<Scalars['String']['output']>;
  affectedByPandemic2020: Scalars['Boolean']['output'];
  airRights?: Maybe<Scalars['String']['output']>;
  airRightsSqFt?: Maybe<Scalars['Float']['output']>;
  apartmentType?: Maybe<Value>;
  approxExteriorSqFt?: Maybe<Scalars['Float']['output']>;
  availableDate?: Maybe<Scalars['DateTime']['output']>;
  basement?: Maybe<Scalars['String']['output']>;
  bathrooms?: Maybe<Scalars['Float']['output']>;
  bedrooms?: Maybe<Scalars['Float']['output']>;
  bonus?: Maybe<Scalars['Boolean']['output']>;
  bonusDescription?: Maybe<Scalars['String']['output']>;
  bonusExpirationDate?: Maybe<Scalars['DateTime']['output']>;
  bonusStartDate?: Maybe<Scalars['DateTime']['output']>;
  buildingAllowed?: Maybe<Array<Value>>;
  buildingAmenities?: Maybe<Array<Value>>;
  buildingClass?: Maybe<Scalars['String']['output']>;
  buildingExtension?: Maybe<Scalars['String']['output']>;
  buildingFeatures?: Maybe<Scalars['String']['output']>;
  buildingManaged?: Maybe<Value>;
  buildingMarketed?: Maybe<Value>;
  buildingName?: Maybe<Scalars['String']['output']>;
  buildingNotAllowed?: Maybe<Array<Value>>;
  buildingPeriod?: Maybe<Value>;
  buildingSize?: Maybe<Scalars['String']['output']>;
  buildingType?: Maybe<Value>;
  closeDate?: Maybe<Scalars['DateTime']['output']>;
  coBrokeAgreement?: Maybe<Scalars['String']['output']>;
  collectYourOwnFee?: Maybe<Scalars['Boolean']['output']>;
  commonOutdoorSpace?: Maybe<Array<Value>>;
  condition?: Maybe<Scalars['String']['output']>;
  constructionType?: Maybe<Value>;
  contacts?: Maybe<ListingSearchContactsViewModel>;
  contractSignedDate?: Maybe<Scalars['DateTime']['output']>;
  crossStreets?: Maybe<Scalars['String']['output']>;
  dealRequirements?: Maybe<Scalars['String']['output']>;
  decorativeFireplace?: Maybe<Scalars['String']['output']>;
  desc?: Maybe<Scalars['String']['output']>;
  dom?: Maybe<Scalars['Int']['output']>;
  doorman?: Maybe<Scalars['String']['output']>;
  doormanRemarks?: Maybe<Scalars['String']['output']>;
  elevators?: Maybe<Scalars['Float']['output']>;
  emailAddress?: Maybe<Scalars['String']['output']>;
  exposures?: Maybe<Array<Value>>;
  extensionSize?: Maybe<Scalars['String']['output']>;
  feePaidBy?: Maybe<Value>;
  financeAllowed?: Maybe<Scalars['Float']['output']>;
  fireplace?: Maybe<Scalars['String']['output']>;
  flipTax?: Maybe<Scalars['String']['output']>;
  flipTaxNum?: Maybe<Scalars['String']['output']>;
  floorLine?: Maybe<Scalars['String']['output']>;
  floorNumber?: Maybe<Scalars['Int']['output']>;
  floors?: Maybe<Scalars['Float']['output']>;
  freeRent?: Maybe<Scalars['Boolean']['output']>;
  freeRentAndOr?: Maybe<Scalars['String']['output']>;
  freeRentDescription?: Maybe<Scalars['String']['output']>;
  freeRentExpirationDate?: Maybe<Scalars['DateTime']['output']>;
  freeRentStartDate?: Maybe<Scalars['DateTime']['output']>;
  fullAddress?: Maybe<Scalars['String']['output']>;
  fullBathrooms?: Maybe<Scalars['Float']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  fullPhoneNumber?: Maybe<Scalars['String']['output']>;
  furnished?: Maybe<Scalars['String']['output']>;
  furnishedPrice?: Maybe<Scalars['Decimal']['output']>;
  garage?: Maybe<Scalars['String']['output']>;
  gasFireplace?: Maybe<Scalars['String']['output']>;
  guarantors?: Maybe<Array<Value>>;
  halfBathrooms?: Maybe<Scalars['Float']['output']>;
  hasHealthClub?: Maybe<Scalars['String']['output']>;
  hasLaundry?: Maybe<Scalars['String']['output']>;
  hasParking?: Maybe<Scalars['String']['output']>;
  hasPool?: Maybe<Scalars['String']['output']>;
  hasRentSaleListing: Scalars['Boolean']['output'];
  hasStorage?: Maybe<Scalars['String']['output']>;
  heatType?: Maybe<Scalars['String']['output']>;
  houseNumberSort?: Maybe<Scalars['Int']['output']>;
  isNewListing: Scalars['Int']['output'];
  isPenthouse?: Maybe<Scalars['Boolean']['output']>;
  isSponsorUnit?: Maybe<Scalars['Boolean']['output']>;
  keyLocations?: Maybe<Array<ValueOfString>>;
  landLease?: Maybe<Scalars['Boolean']['output']>;
  landlord?: Maybe<Scalars['String']['output']>;
  lastAskPrice: Scalars['Float']['output'];
  latitude?: Maybe<Scalars['Float']['output']>;
  leaseTerm?: Maybe<Value>;
  leaseType?: Maybe<Value>;
  listedDate?: Maybe<Scalars['DateTime']['output']>;
  listingCategory?: Maybe<Scalars['String']['output']>;
  listingCategoryId: Scalars['Int']['output'];
  listingCompany?: Maybe<Scalars['String']['output']>;
  listingCompanyName?: Maybe<Scalars['String']['output']>;
  listingId: Scalars['Int']['output'];
  listingNumber?: Maybe<Scalars['String']['output']>;
  listingNumberReference?: Maybe<Scalars['String']['output']>;
  listingType?: Maybe<Value>;
  lobbyAttendants?: Maybe<Array<Value>>;
  longitude?: Maybe<Scalars['Float']['output']>;
  lotSize?: Maybe<Scalars['String']['output']>;
  maidBath?: Maybe<Scalars['Float']['output']>;
  maidBed?: Maybe<Scalars['Float']['output']>;
  maintCC?: Maybe<Scalars['Float']['output']>;
  managementCompany?: Maybe<Array<Scalars['String']['output']>>;
  manhattanGridSort?: Maybe<Scalars['String']['output']>;
  maxLeaseTerm?: Maybe<Scalars['Int']['output']>;
  media?: Maybe<Media>;
  minLeaseTerm?: Maybe<Scalars['Int']['output']>;
  miscellaneous?: Maybe<Array<Value>>;
  monthlyExpence?: Maybe<Scalars['Float']['output']>;
  multifloor?: Maybe<Value>;
  neighborhood?: Maybe<Scalars['String']['output']>;
  neighborhoodCode?: Maybe<Scalars['String']['output']>;
  neighborhoodId?: Maybe<Scalars['Int']['output']>;
  nextOpenhouseSortDate?: Maybe<Scalars['Long']['output']>;
  nextOpenhouseSortTime?: Maybe<Scalars['Int']['output']>;
  nonMarketSale: Scalars['Boolean']['output'];
  op?: Maybe<Scalars['String']['output']>;
  openHouse?: Maybe<Scalars['String']['output']>;
  openHouseEnd?: Maybe<Scalars['DateTime']['output']>;
  openHouseStart?: Maybe<Scalars['DateTime']['output']>;
  openHouseType?: Maybe<Value>;
  openHousesCount?: Maybe<Scalars['Int']['output']>;
  originalPrice?: Maybe<Scalars['Float']['output']>;
  owner?: Maybe<Scalars['String']['output']>;
  ownerPays?: Maybe<Scalars['Boolean']['output']>;
  ownerPaysAndOr?: Maybe<Scalars['String']['output']>;
  ownerPaysDescription?: Maybe<Scalars['String']['output']>;
  ownerPaysExpirationDate?: Maybe<Scalars['DateTime']['output']>;
  ownerPaysStartDate?: Maybe<Scalars['DateTime']['output']>;
  ownership?: Maybe<Scalars['String']['output']>;
  petsAllowed?: Maybe<Scalars['String']['output']>;
  postalAddressID?: Maybe<Scalars['Int']['output']>;
  prefix?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Decimal']['output']>;
  priceChange?: Maybe<LastPriceChange>;
  priceIndicator?: Maybe<Scalars['String']['output']>;
  pricePerRoom?: Maybe<Scalars['Float']['output']>;
  pricePerShare?: Maybe<Scalars['Float']['output']>;
  pricePerSqFt?: Maybe<Scalars['Float']['output']>;
  privateOutdoorSpace?: Maybe<Array<Value>>;
  propertyId?: Maybe<Scalars['Int']['output']>;
  reTax?: Maybe<Scalars['Float']['output']>;
  rentDate?: Maybe<Scalars['DateTime']['output']>;
  rooms?: Maybe<Scalars['Float']['output']>;
  rpBin?: Maybe<Scalars['Int']['output']>;
  secureGroup?: Maybe<Scalars['String']['output']>;
  shares?: Maybe<Scalars['Int']['output']>;
  showingInstructions?: Maybe<Scalars['String']['output']>;
  soldDate?: Maybe<Scalars['DateTime']['output']>;
  soldPrice?: Maybe<Scalars['Float']['output']>;
  sortOH?: Maybe<Scalars['Int']['output']>;
  squareFootage?: Maybe<Scalars['Float']['output']>;
  status: Value;
  streetGrid?: Maybe<StreetGridViewModel>;
  streetName?: Maybe<Scalars['String']['output']>;
  subletAllowed?: Maybe<Scalars['String']['output']>;
  suffix?: Maybe<Scalars['String']['output']>;
  taxDeduction?: Maybe<Scalars['Float']['output']>;
  totalCommission?: Maybe<Scalars['String']['output']>;
  townhouseFeatures?: Maybe<Array<Value>>;
  townhouseType?: Maybe<Value>;
  typeOfAc?: Maybe<Scalars['String']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
  units?: Maybe<Scalars['Float']['output']>;
  updatedDate?: Maybe<Scalars['DateTime']['output']>;
  verified: Scalars['Boolean']['output'];
  views?: Maybe<Array<Value>>;
  washerDryer?: Maybe<Scalars['String']['output']>;
  webId?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['Float']['output']>;
  woodBurningFireplace?: Maybe<Scalars['String']['output']>;
  yearBuilt?: Maybe<Scalars['Float']['output']>;
  yearIncorporated?: Maybe<Scalars['Float']['output']>;
  zipcode?: Maybe<Scalars['String']['output']>;
  zoning?: Maybe<Scalars['String']['output']>;
};

export type ListingSettingsModel = {
  __typename?: 'ListingSettingsModel';
  accessDataEntryLink?: Maybe<Scalars['Boolean']['output']>;
  adManager?: Maybe<Scalars['Boolean']['output']>;
  advertise?: Maybe<Scalars['Boolean']['output']>;
  ellimanMMSLink?: Maybe<Scalars['Boolean']['output']>;
  listingId: Scalars['Int']['output'];
  manageMediaLink?: Maybe<Scalars['Boolean']['output']>;
  oneClickLink?: Maybe<Scalars['Boolean']['output']>;
  quickEditLink?: Maybe<Scalars['Boolean']['output']>;
  uniq: Scalars['Int']['output'];
  updateStagingCost?: Maybe<Scalars['Boolean']['output']>;
  wellcomeMatLink?: Maybe<Scalars['Boolean']['output']>;
};

export type ListingStats = {
  __typename?: 'ListingStats';
  collaborationStats?: Maybe<ListingCollaborationStatsViewModel>;
  listingId: Scalars['Int']['output'];
};


export type ListingStatsCollaborationStatsArgs = {
  customerId: Scalars['Int']['input'];
};

export type ListingStatsNode = {
  __typename?: 'ListingStatsNode';
  hasMarketListings: Scalars['Boolean']['output'];
  hasNewMatches: Scalars['Boolean']['output'];
  listingSettings: Array<ListingSettingsModel>;
};


export type ListingStatsNodeHasMarketListingsArgs = {
  input: HasMarketListingsInput;
};


export type ListingStatsNodeHasNewMatchesArgs = {
  input: HasNewMatchesInput;
};


export type ListingStatsNodeListingSettingsArgs = {
  input: GetListingsSettingsInput;
};

export enum ListingType {
  CoExclusive = 'CO_EXCLUSIVE',
  Exclusive = 'EXCLUSIVE',
  ForSaleByOwner = 'FOR_SALE_BY_OWNER',
  Limited = 'LIMITED',
  Open = 'OPEN',
  OursAlone = 'OURS_ALONE'
}

export type ListingViewModel = {
  __typename?: 'ListingViewModel';
  address: Scalars['String']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
};

export type ListingsEventInput = {
  collaborationId: Scalars['Int']['input'];
  createId: Scalars['Int']['input'];
  listingsIds: Array<Scalars['Int']['input']>;
};

export enum ListingsSortingField {
  Address = 'ADDRESS',
  Bedrooms = 'BEDROOMS',
  DateListed = 'DATE_LISTED',
  DateUpdatedOrSold = 'DATE_UPDATED_OR_SOLD',
  ListingCompany = 'LISTING_COMPANY',
  MaintCc = 'MAINT_CC',
  ManhattanGrid = 'MANHATTAN_GRID',
  Neighborhood = 'NEIGHBORHOOD',
  Price = 'PRICE',
  ReTaxes = 'RE_TAXES',
  Rooms = 'ROOMS',
  SqFt = 'SQ_FT',
  Status = 'STATUS',
  Unit = 'UNIT'
}

export type LogicalIdsCriteria = {
  __typename?: 'LogicalIdsCriteria';
  ids: Array<Scalars['Int']['output']>;
  operation?: Maybe<LogicalOperation>;
};

export type LogicalIdsCriteriaInput = {
  ids: Array<Scalars['Int']['input']>;
  operation?: InputMaybe<LogicalOperation>;
};

export enum LogicalOperation {
  And = 'AND',
  Or = 'OR'
}

export type ManageListingsFoldersInput = {
  customerId?: InputMaybe<Scalars['Int']['input']>;
  foldersListingsAttachments?: InputMaybe<FolderListingsAttachmentManageInput>;
  foldersListingsDetachments?: InputMaybe<FolderListingsAttachmentManageInput>;
};

export type ManageSavedSearchFoldersInput = {
  customerId?: InputMaybe<Scalars['Int']['input']>;
  foldersSavedSearchAttachments?: InputMaybe<FolderSavedSearchesAttachmentManageInput>;
  foldersSavedSearchDetachments?: InputMaybe<FolderSavedSearchesAttachmentManageInput>;
};

export type MapCircle = {
  __typename?: 'MapCircle';
  coordinate: MapCoordinate;
  radius: Scalars['Float']['output'];
};

export type MapCircleInput = {
  coordinate: MapCoordinateInput;
  radius: Scalars['Float']['input'];
};

export type MapCoordinate = {
  __typename?: 'MapCoordinate';
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
};

export type MapCoordinateInput = {
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
};

export type MapPolygon = {
  __typename?: 'MapPolygon';
  coordinates: Array<MapCoordinate>;
};

export type MapPolygonInput = {
  coordinates: Array<MapCoordinateInput>;
};

export type MapShapeCriteria = {
  __typename?: 'MapShapeCriteria';
  circles?: Maybe<Array<MapCircle>>;
  polygons?: Maybe<Array<MapPolygon>>;
};

export type MapShapeCriteriaInput = {
  circles?: InputMaybe<Array<MapCircleInput>>;
  polygons?: InputMaybe<Array<MapPolygonInput>>;
};

export type MarkAllCommentsAsViewedInput = {
  customerCollaborationId: Scalars['Int']['input'];
  listingId: Scalars['Int']['input'];
};

export type MarkCommentsAsViewedInput = {
  commentsIds: Array<Scalars['Int']['input']>;
  customerCollaborationId: Scalars['Int']['input'];
};

export type Media = {
  __typename?: 'Media';
  originalImages: Array<StoredMedia>;
  tours: Array<VirtualTour>;
  videos: Array<Video>;
};

export enum MediaKind {
  FloorPlan = 'FLOOR_PLAN',
  Photo = 'PHOTO',
  Unknown = 'UNKNOWN',
  Video = 'VIDEO',
  VideoTour = 'VIDEO_TOUR'
}

export enum MediaOrientation {
  Landscape = 'LANDSCAPE',
  Portrait = 'PORTRAIT',
  Unknown = 'UNKNOWN'
}

export enum MediaRecordType {
  Listing = 'LISTING',
  Property = 'PROPERTY',
  Unknown = 'UNKNOWN'
}

export type MinMaxCriteria = {
  __typename?: 'MinMaxCriteria';
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
};

export type MinMaxCriteriaInput = {
  max?: InputMaybe<Scalars['Float']['input']>;
  min?: InputMaybe<Scalars['Float']['input']>;
};

export type MinMaxInput = {
  max?: InputMaybe<Scalars['Float']['input']>;
  min?: InputMaybe<Scalars['Float']['input']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  addCustomer: Scalars['Int']['output'];
  addListingActivity: Array<Scalars['Int']['output']>;
  addListingComment: Scalars['Int']['output'];
  appointments: AppointmentMutationExtensions;
  createFolder: Scalars['Int']['output'];
  deactivateCustomer: Scalars['Boolean']['output'];
  deleteCustomer: Scalars['Boolean']['output'];
  deleteNewMatches: Scalars['Boolean']['output'];
  deleteSavedSearch: Scalars['Boolean']['output'];
  editCustomer: Scalars['Int']['output'];
  inviteCustomer: InviteCustomerOutput;
  manageListingsFolders: Scalars['Boolean']['output'];
  manageSavedSearchFolders: Scalars['Boolean']['output'];
  markAllCommentsAsViewed: Acknowledge;
  markCommentsAsViewed: Acknowledge;
  notes: NotesMutationNode;
  notifications: NotificationsMutations;
  permanentlyDeleteCustomer: Scalars['Boolean']['output'];
  ping: Scalars['String']['output'];
  reactivateCustomer: Scalars['Boolean']['output'];
  removeFolder: Scalars['Boolean']['output'];
  removeListingActivity: Array<Scalars['Int']['output']>;
  removeListings: Acknowledge;
  restoreCustomer: Scalars['Boolean']['output'];
  restoreListings: Scalars['Boolean']['output'];
  revokeInvitation: RevokeInvitationOutput;
  saveSearchCriteria: Scalars['Int']['output'];
  setSavedSearchAsDefault: Scalars['Int']['output'];
  updateCommentText: Acknowledge;
  updateFolder: Scalars['Boolean']['output'];
  updateHideEmptyListingDetailsPreferences: Acknowledge;
};


export type MutationAddCustomerArgs = {
  input: AddCustomerInput;
};


export type MutationAddListingActivityArgs = {
  input: AddListingActivityInput;
};


export type MutationAddListingCommentArgs = {
  input: AddListingCommentInput;
};


export type MutationCreateFolderArgs = {
  input: CreateFolderInput;
};


export type MutationDeactivateCustomerArgs = {
  customerId: Scalars['Int']['input'];
};


export type MutationDeleteCustomerArgs = {
  customerId: Scalars['Int']['input'];
};


export type MutationDeleteNewMatchesArgs = {
  input: DeleteNewMatchesInput;
};


export type MutationDeleteSavedSearchArgs = {
  id: Scalars['Int']['input'];
};


export type MutationEditCustomerArgs = {
  input: EditCustomerInput;
};


export type MutationInviteCustomerArgs = {
  input: InviteCustomerInput;
};


export type MutationManageListingsFoldersArgs = {
  input: ManageListingsFoldersInput;
};


export type MutationManageSavedSearchFoldersArgs = {
  input: ManageSavedSearchFoldersInput;
};


export type MutationMarkAllCommentsAsViewedArgs = {
  input: MarkAllCommentsAsViewedInput;
};


export type MutationMarkCommentsAsViewedArgs = {
  input: MarkCommentsAsViewedInput;
};


export type MutationPermanentlyDeleteCustomerArgs = {
  customerId: Scalars['Int']['input'];
};


export type MutationReactivateCustomerArgs = {
  customerId: Scalars['Int']['input'];
};


export type MutationRemoveFolderArgs = {
  input: RemoveFolderInput;
};


export type MutationRemoveListingActivityArgs = {
  input: RemoveListingActivityInput;
};


export type MutationRemoveListingsArgs = {
  input: RemoveListingsInput;
};


export type MutationRestoreCustomerArgs = {
  customerId: Scalars['Int']['input'];
};


export type MutationRestoreListingsArgs = {
  input: RestoreListingsInput;
};


export type MutationRevokeInvitationArgs = {
  customerId: Scalars['Int']['input'];
};


export type MutationSaveSearchCriteriaArgs = {
  input: SaveSearchCriteriaInput;
};


export type MutationSetSavedSearchAsDefaultArgs = {
  id: Scalars['Int']['input'];
};


export type MutationUpdateCommentTextArgs = {
  input: UpdateCommentTextInput;
};


export type MutationUpdateFolderArgs = {
  input: UpdateFolderInput;
};


export type MutationUpdateHideEmptyListingDetailsPreferencesArgs = {
  hideEmptyDetails: Scalars['Boolean']['input'];
};

export type MyCustomer = {
  __typename?: 'MyCustomer';
  additionalInfo: Array<PersonAttributeText>;
  addresses: Array<AddressPersonInfo>;
  contactAddress?: Maybe<Scalars['String']['output']>;
  contactEmail?: Maybe<Scalars['String']['output']>;
  contactSource?: Maybe<Scalars['String']['output']>;
  createDateTime?: Maybe<Scalars['DateTime']['output']>;
  customerCollaborationId?: Maybe<Scalars['Int']['output']>;
  customerSharingID?: Maybe<Scalars['Int']['output']>;
  dislikes?: Maybe<Scalars['Int']['output']>;
  emailSignature?: Maybe<Scalars['String']['output']>;
  emails: Array<EmailPersonInfo>;
  firstGivenName: Scalars['String']['output'];
  fromAgentName?: Maybe<Scalars['String']['output']>;
  hotProspect?: Maybe<Scalars['Int']['output']>;
  invitationCreatedDate?: Maybe<Scalars['DateTime']['output']>;
  invitationExpirationDate?: Maybe<Scalars['DateTime']['output']>;
  invitationStatus?: Maybe<Scalars['String']['output']>;
  isDeActivated?: Maybe<Scalars['Boolean']['output']>;
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  isOwnedByAgent?: Maybe<Scalars['Boolean']['output']>;
  isShared?: Maybe<Scalars['Boolean']['output']>;
  likes?: Maybe<Scalars['Int']['output']>;
  myListings?: Maybe<Scalars['Int']['output']>;
  myListingsCount?: Maybe<Scalars['Int']['output']>;
  newMatches?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  notifications?: Maybe<Scalars['String']['output']>;
  personId: Scalars['Int']['output'];
  personName?: Maybe<Scalars['String']['output']>;
  phones: Array<PhonePersonInfo>;
  pick?: Maybe<Scalars['Int']['output']>;
  savedSearches?: Maybe<Scalars['String']['output']>;
  secondGivenName: Scalars['String']['output'];
  sharingTypeId?: Maybe<Scalars['Int']['output']>;
  status: PersonStatus;
  uniq: Scalars['Int']['output'];
  updateDateTime?: Maybe<Scalars['DateTime']['output']>;
  userPrefMapCenter?: Maybe<Scalars['String']['output']>;
  userPrefMapCenterName?: Maybe<Scalars['String']['output']>;
  userProfilePic?: Maybe<Scalars['String']['output']>;
  useractivesince?: Maybe<Scalars['String']['output']>;
  viewed?: Maybe<Scalars['Int']['output']>;
};

export type NewMatchBasicInfo = {
  __typename?: 'NewMatchBasicInfo';
  fullAddress?: Maybe<Scalars['String']['output']>;
  listingAddress: Scalars['String']['output'];
  listingCategoryId: Scalars['Int']['output'];
  listingId: Scalars['Int']['output'];
  listingPhoto?: Maybe<Scalars['String']['output']>;
  listingUnit?: Maybe<Scalars['String']['output']>;
  newMatchRecordId: Scalars['Int']['output'];
  price: Scalars['Float']['output'];
  searchOwnerProfileImage?: Maybe<Scalars['String']['output']>;
};

export enum NewMatchReason {
  MainCcChanged = 'MAIN_CC_CHANGED',
  NewListing = 'NEW_LISTING',
  PriceChanged = 'PRICE_CHANGED',
  StatusChanged = 'STATUS_CHANGED'
}

export type NewMatchesExtensions = {
  __typename?: 'NewMatchesExtensions';
  newMatchListings: Array<ListingBasicInfo>;
  newMatchListingsIds: Array<Scalars['Int']['output']>;
  newMatchesBasicInfo: Array<NewMatchBasicInfo>;
};


export type NewMatchesExtensionsNewMatchListingsArgs = {
  input: GetNewMatchListingsInput;
};


export type NewMatchesExtensionsNewMatchListingsIdsArgs = {
  input: GetNewMatchListingsIdsInput;
};


export type NewMatchesExtensionsNewMatchesBasicInfoArgs = {
  input: GetNewMatchesBasicInfoInput;
};

export type NotesMutationNode = {
  __typename?: 'NotesMutationNode';
  delete: Acknowledge;
  upsert: Array<ListingNote>;
};


export type NotesMutationNodeDeleteArgs = {
  notes: Array<Scalars['Int']['input']>;
};


export type NotesMutationNodeUpsertArgs = {
  notes: Array<UpsertListingNoteInput>;
};

export enum NotificationEntityType {
  Appointment = 'APPOINTMENT',
  Comment = 'COMMENT',
  ExternalListing = 'EXTERNAL_LISTING',
  Folder = 'FOLDER',
  Listing = 'LISTING',
  ListingActivity = 'LISTING_ACTIVITY',
  NewMatch = 'NEW_MATCH'
}

export type NotificationViewModel = {
  __typename?: 'NotificationViewModel';
  action: EventAction;
  appointment?: Maybe<AppointmentViewModel>;
  collaborationId: Scalars['Int']['output'];
  comment?: Maybe<CommentViewModel>;
  createDate: Scalars['DateTime']['output'];
  createId: Scalars['Int']['output'];
  entityDate?: Maybe<Scalars['DateTime']['output']>;
  entityId: Scalars['Int']['output'];
  entityType: NotificationEntityType;
  isViewed: Scalars['Boolean']['output'];
  listing?: Maybe<ListingViewModel>;
  listingId?: Maybe<Scalars['Int']['output']>;
  notificationId: Scalars['Int']['output'];
  userId: Scalars['Int']['output'];
};

export enum NotificationsGraphQl_AppointmentStatus {
  Confirmed = 'CONFIRMED',
  Declined = 'DECLINED',
  Pending = 'PENDING',
  Shown = 'SHOWN'
}

export type NotificationsGraphQl_RemoveListingActivityInput = {
  agentListingPinIds: Array<Scalars['Int']['input']>;
  collaborationId: Scalars['Int']['input'];
  date: Scalars['DateTime']['input'];
};

export type NotificationsMutations = {
  __typename?: 'NotificationsMutations';
  events: EventsMutations;
  pushNotifications: PushNotificationMutations;
  remove: Acknowledge;
  removeByEntities: Acknowledge;
  removeByListings: Acknowledge;
  removeByUsers: Acknowledge;
  viewUnviewNotifications: Acknowledge;
};


export type NotificationsMutationsRemoveArgs = {
  notificationIds: Array<Scalars['Int']['input']>;
};


export type NotificationsMutationsRemoveByEntitiesArgs = {
  input: RemoveByEntitiesInput;
};


export type NotificationsMutationsRemoveByListingsArgs = {
  input: RemoveNotificationsByListingsInput;
};


export type NotificationsMutationsRemoveByUsersArgs = {
  userIds: Array<Scalars['Int']['input']>;
};


export type NotificationsMutationsViewUnviewNotificationsArgs = {
  notificationIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type OfficeCriteria = {
  __typename?: 'OfficeCriteria';
  ids: Array<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
};

export type OfficeCriteriaInput = {
  ids: Array<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
};

export type OfficeExtensions = {
  __typename?: 'OfficeExtensions';
  byCompany: Array<CompanyOfficeBasicInfo>;
};

export type OfficesCriteria = {
  __typename?: 'OfficesCriteria';
  offices: Array<OfficeCriteria>;
};

export type OfficesCriteriaInput = {
  offices: Array<OfficeCriteriaInput>;
};

export type OmniSearchCriteria = {
  __typename?: 'OmniSearchCriteria';
  values: Array<OmniSearchItem>;
};

export type OmniSearchCriteriaInput = {
  values: Array<OmniSearchItemInput>;
};

export type OmniSearchItem = {
  __typename?: 'OmniSearchItem';
  ids: Array<Maybe<Scalars['String']['output']>>;
  kind: OmniSearchSections;
  text: Scalars['String']['output'];
};

export type OmniSearchItemInput = {
  ids: Array<InputMaybe<Scalars['String']['input']>>;
  kind: OmniSearchSections;
  text: Scalars['String']['input'];
};

export type OmniSearchResult = {
  __typename?: 'OmniSearchResult';
  ids: Array<Maybe<Scalars['String']['output']>>;
  kind: OmniSearchSections;
  value: Scalars['String']['output'];
};

export enum OmniSearchSections {
  Address = 'ADDRESS',
  AddressRange = 'ADDRESS_RANGE',
  Borough = 'BOROUGH',
  BuildingName = 'BUILDING_NAME',
  Listing = 'LISTING',
  Neighborhood = 'NEIGHBORHOOD',
  Section = 'SECTION',
  Street = 'STREET',
  Web = 'WEB'
}

export type OpenHouse = {
  __typename?: 'OpenHouse';
  address?: Maybe<Scalars['String']['output']>;
  agent?: Maybe<Scalars['String']['output']>;
  appointmentOnly: Scalars['Boolean']['output'];
  comment?: Maybe<Scalars['String']['output']>;
  disliked?: Maybe<Scalars['Boolean']['output']>;
  emailed?: Maybe<Scalars['Boolean']['output']>;
  endDateTime: Scalars['DateTime']['output'];
  floorLine?: Maybe<Scalars['String']['output']>;
  floorNumber?: Maybe<Scalars['Int']['output']>;
  fullAddress?: Maybe<Scalars['String']['output']>;
  hasWebLinks: Scalars['Boolean']['output'];
  houseNumberSort?: Maybe<Scalars['Int']['output']>;
  isNewMatch?: Maybe<Scalars['Boolean']['output']>;
  liked?: Maybe<Scalars['Boolean']['output']>;
  listingCategoryId: Scalars['Int']['output'];
  listingId: Scalars['Int']['output'];
  listingNumber?: Maybe<Scalars['String']['output']>;
  listingOpenHouseId: Scalars['Int']['output'];
  listingPhoto?: Maybe<Scalars['String']['output']>;
  manhattanGridSort?: Maybe<Scalars['String']['output']>;
  newMatchDate?: Maybe<Scalars['DateTime']['output']>;
  newMatchReason?: Maybe<Scalars['String']['output']>;
  officeCode?: Maybe<Scalars['String']['output']>;
  officeDetail?: Maybe<Scalars['String']['output']>;
  pickListed?: Maybe<Scalars['Boolean']['output']>;
  prefix?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Decimal']['output']>;
  sortTime?: Maybe<Scalars['Int']['output']>;
  startDateTime: Scalars['DateTime']['output'];
  streetName?: Maybe<Scalars['String']['output']>;
  suffix?: Maybe<Scalars['String']['output']>;
  totalCommission?: Maybe<Scalars['String']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
  visited?: Maybe<Scalars['Boolean']['output']>;
};

export type OpenHouseCriteria = {
  __typename?: 'OpenHouseCriteria';
  date?: Maybe<DateRangeCriteria>;
  openHouseType?: Maybe<Array<OpenHouseType>>;
};

export type OpenHouseCriteriaInput = {
  date?: InputMaybe<DateRangeCriteriaInput>;
  openHouseType?: InputMaybe<Array<OpenHouseType>>;
};

export enum OpenHouseType {
  Any = 'ANY',
  BrokerOnly = 'BROKER_ONLY',
  ByAppointment = 'BY_APPOINTMENT',
  None = 'NONE',
  Public = 'PUBLIC',
  Virtual = 'VIRTUAL'
}

export type OpenHousesExtension = {
  __typename?: 'OpenHousesExtension';
  agentOpenHouses: Array<OpenHouse>;
  customerOpenHouses: Array<OpenHouse>;
  openHouseListingsIds: Array<Scalars['Int']['output']>;
};


export type OpenHousesExtensionAgentOpenHousesArgs = {
  input: GetAgentOpenHousesInput;
};


export type OpenHousesExtensionCustomerOpenHousesArgs = {
  input: GetCustomerOpenHousesInput;
};


export type OpenHousesExtensionOpenHouseListingsIdsArgs = {
  input: GetOpenHouseListingsIdsInput;
};

export type OwnerPays = {
  __typename?: 'OwnerPays';
  andOr?: Maybe<ValueOfAndOr>;
  description?: Maybe<Scalars['String']['output']>;
  expirationDate?: Maybe<Scalars['DateTime']['output']>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  value?: Maybe<ValueOfYesNoUnknown>;
};

export type PermissionSettings = {
  __typename?: 'PermissionSettings';
  allowMultipleProfiles: Scalars['Boolean']['output'];
  canSearchForListings: Scalars['Boolean']['output'];
  hideOpenRentals: Scalars['Boolean']['output'];
};

export type Person = {
  __typename?: 'Person';
  avatarUrl?: Maybe<Scalars['String']['output']>;
  companyId?: Maybe<Scalars['Int']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  fullName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
};

export enum PersonAttribute {
  Birthday = 'BIRTHDAY',
  Facebook = 'FACEBOOK',
  Instagram = 'INSTAGRAM',
  InstantMessaging = 'INSTANT_MESSAGING',
  Linkedin = 'LINKEDIN',
  Nickname = 'NICKNAME',
  PersonProfilePic = 'PERSON_PROFILE_PIC',
  Relationship = 'RELATIONSHIP',
  Title = 'TITLE',
  Twitter = 'TWITTER',
  Url = 'URL'
}

export type PersonAttributeText = {
  __typename?: 'PersonAttributeText';
  attributeType: PersonAttribute;
  attributeValue: Scalars['String']['output'];
};

export type PersonAttributeTextInput = {
  attributeType: PersonAttribute;
  attributeValue: Scalars['String']['input'];
};

export enum PersonStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

export enum PersonType {
  Agent = 'AGENT',
  Customer = 'CUSTOMER'
}

export type PhonePersonInfo = {
  __typename?: 'PhonePersonInfo';
  phoneNumberText: Scalars['String']['output'];
  phoneType: PhoneType;
};

export type PhonePersonInfoInput = {
  phoneNumberText: Scalars['String']['input'];
  phoneType: PhoneType;
};

export enum PhoneType {
  Home = 'HOME',
  Mobile = 'MOBILE',
  Office = 'OFFICE',
  Other = 'OTHER'
}

export type PriceChangeCriteria = {
  __typename?: 'PriceChangeCriteria';
  dateRange?: Maybe<DateRangeCriteria>;
  isIncrease: Scalars['Boolean']['output'];
  minMax?: Maybe<MinMaxCriteria>;
};

export type PriceChangeCriteriaInput = {
  dateRange?: InputMaybe<DateRangeCriteriaInput>;
  isIncrease: Scalars['Boolean']['input'];
  minMax?: InputMaybe<MinMaxCriteriaInput>;
};

export type PriceCriteria = {
  __typename?: 'PriceCriteria';
  minMax: MinMaxCriteria;
};

export type PriceCriteriaInput = {
  minMax: MinMaxCriteriaInput;
};

export enum PrivateOutdoorSpace {
  Any = 'ANY',
  Balcony = 'BALCONY',
  Deck = 'DECK',
  Garden = 'GARDEN',
  Greenhouse = 'GREENHOUSE',
  JulietBalcony = 'JULIET_BALCONY',
  None = 'NONE',
  Other = 'OTHER',
  Patio = 'PATIO',
  PrivateRoofAccess = 'PRIVATE_ROOF_ACCESS',
  RoofDeck = 'ROOF_DECK',
  RoofRights = 'ROOF_RIGHTS',
  Terrace = 'TERRACE',
  WrapTerrace = 'WRAP_TERRACE'
}

export type PushNotificationMutations = {
  __typename?: 'PushNotificationMutations';
  deleteToken: Acknowledge;
  upsertToken: UpsertPushNotificationTokenOutput;
};


export type PushNotificationMutationsDeleteTokenArgs = {
  token: Scalars['String']['input'];
};


export type PushNotificationMutationsUpsertTokenArgs = {
  input: PushNotificationTokenInput;
};

export enum PushNotificationProvider {
  Firebase = 'FIREBASE',
  OneSignal = 'ONE_SIGNAL'
}

export type PushNotificationTokenInput = {
  provider: PushNotificationProvider;
  token: Scalars['String']['input'];
};

export type Query = {
  __typename?: 'Query';
  agent: AgentExtensions;
  appointments: AppointmentsExtensions;
  collaboration: CollaborationPortfolioViewModel;
  comments: CommentsExtensions;
  customer: CustomerExtensions;
  folders: FolderExtensions;
  listing: Listing;
  listingStats: ListingStatsNode;
  listings: Array<Listing>;
  newMatches: NewMatchesExtensions;
  notifications: Array<NotificationViewModel>;
  openHouses: OpenHousesExtension;
  search: SearchExtensions;
  version: Scalars['String']['output'];
};


export type QueryCollaborationArgs = {
  collaborationId: Scalars['Int']['input'];
};


export type QueryListingArgs = {
  id: Scalars['Int']['input'];
};


export type QueryListingsArgs = {
  ids: Array<Scalars['Int']['input']>;
};

export type RpFileInput = {
  bytes: Array<Scalars['Byte']['input']>;
  contentType: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
};

export type RemoveByEntitiesInput = {
  entitiesIds: Array<Scalars['Int']['input']>;
  entityType: NotificationEntityType;
};

export type RemoveFolderInput = {
  customerId?: InputMaybe<Scalars['Int']['input']>;
  folderId: Scalars['Int']['input'];
  includeListings: Scalars['Boolean']['input'];
};

export type RemoveListingActivityInput = {
  action: ActivityAction;
  customersIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  listingsIds: Array<Scalars['Int']['input']>;
};

export type RemoveListingsInput = {
  customerId?: InputMaybe<Scalars['Int']['input']>;
  isHardDelete?: InputMaybe<Scalars['Boolean']['input']>;
  listingsIds: Array<Scalars['Int']['input']>;
};

export type RemoveNotificationsByListingsInput = {
  collaborationId: Scalars['Int']['input'];
  listingsIds: Array<Scalars['Int']['input']>;
};

export type RentSaleFlagViewModel = {
  __typename?: 'RentSaleFlagViewModel';
  currentPrice: Scalars['Decimal']['output'];
  currentStatus: Scalars['String']['output'];
  listedDate: Scalars['DateTime']['output'];
  listingCategoryId: ListingCategoryType;
  listingId: Scalars['Int']['output'];
  listingNumber: Scalars['String']['output'];
  updatedDate?: Maybe<Scalars['DateTime']['output']>;
};

export type RestoreListingsInput = {
  agentId: Scalars['Int']['input'];
  customerId?: InputMaybe<Scalars['Int']['input']>;
  listingsIds: Array<Scalars['Int']['input']>;
};

export type RevokeInvitationOutput = {
  __typename?: 'RevokeInvitationOutput';
  agentId: Scalars['Int']['output'];
  createdDate: Scalars['DateTime']['output'];
  customerCollaborationId: Scalars['Int']['output'];
  customerId: Scalars['Int']['output'];
  lastActivityStatus: Scalars['String']['output'];
};

export type RoomsCriteria = {
  __typename?: 'RoomsCriteria';
  minMax?: Maybe<MinMaxCriteria>;
  values?: Maybe<ValuesCriteria>;
};

export type RoomsCriteriaInput = {
  minMax?: InputMaybe<MinMaxCriteriaInput>;
  values?: InputMaybe<ValuesCriteriaInput>;
};

export type SaveSearchCriteriaInput = {
  agentId: Scalars['Int']['input'];
  criteria: SearchCriteriaInput;
  customerId?: InputMaybe<Scalars['Int']['input']>;
  emailCustomerNewMatches: Scalars['Boolean']['input'];
  emailMeNewMatches: Scalars['Boolean']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  includeInNewMatches: Scalars['Boolean']['input'];
  isDefault: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  postNewMatchesToCustomerCollaboration: Scalars['Boolean']['input'];
};

export type SavedSearchExtensions = {
  __typename?: 'SavedSearchExtensions';
  default: Array<SavedSearchModel>;
  savedSearch: SavedSearchModel;
  savedSearches: Array<SavedSearchModel>;
  savedSearchesCount: Scalars['Int']['output'];
  searchHistory: Array<AutoSavedSearch>;
};


export type SavedSearchExtensionsSavedSearchArgs = {
  savedSearchId: Scalars['Int']['input'];
};


export type SavedSearchExtensionsSavedSearchesArgs = {
  input: GetSavedSearchesInput;
};


export type SavedSearchExtensionsSearchHistoryArgs = {
  input: GetSearchHistoryInput;
};

export type SavedSearchModel = {
  __typename?: 'SavedSearchModel';
  agentId: Scalars['Int']['output'];
  createDateTime: Scalars['DateTime']['output'];
  createId: Scalars['Int']['output'];
  creatorFirstName: Scalars['String']['output'];
  creatorLastName: Scalars['String']['output'];
  creatorProfileImageUrl?: Maybe<Scalars['String']['output']>;
  creatorType: PersonType;
  criteria?: Maybe<SearchCriteria>;
  customerId?: Maybe<Scalars['Int']['output']>;
  emailCustomerNewMatches: Scalars['Boolean']['output'];
  emailMeNewMatches: Scalars['Boolean']['output'];
  folders: Array<Folder>;
  id: Scalars['Int']['output'];
  includeInNewMatches: Scalars['Boolean']['output'];
  isDefault: Scalars['Boolean']['output'];
  isDeleted: Scalars['Boolean']['output'];
  lastNewMatchesDate?: Maybe<Scalars['DateTime']['output']>;
  lastRunDate: Scalars['DateTime']['output'];
  listingCategoryId: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  newMatchesCount: Scalars['Int']['output'];
  postNewMatchesToCustomerCollaboration: Scalars['Boolean']['output'];
  updateDateTime?: Maybe<Scalars['DateTime']['output']>;
};

export type SearchCriteria = {
  __typename?: 'SearchCriteria';
  addresses?: Maybe<Array<AddressCriteria>>;
  agentPhones?: Maybe<Array<Scalars['String']['output']>>;
  agentTags?: Maybe<Array<Scalars['String']['output']>>;
  agents?: Maybe<AgentsCriteria>;
  apartmentTypes?: Maybe<IdsCriteria>;
  attendedLobby?: Maybe<LogicalIdsCriteria>;
  availability?: Maybe<DateRangeCriteria>;
  availableMedia?: Maybe<IdsCriteria>;
  bathrooms?: Maybe<BathroomsCriteria>;
  bedrooms?: Maybe<BedroomsCriteria>;
  buildingAllowed?: Maybe<IdsCriteria>;
  buildingAmenities?: Maybe<IdsCriteria>;
  buildingContracts?: Maybe<BuildingContractsCriteria>;
  buildingFinancing?: Maybe<MinMaxCriteria>;
  buildingFloors?: Maybe<MinMaxCriteria>;
  buildingManaged?: Maybe<IdsCriteria>;
  buildingMarketed?: Maybe<IdsCriteria>;
  buildingNotAllowed?: Maybe<IdsCriteria>;
  buildingPeriod?: Maybe<IdsCriteria>;
  buildingTypes?: Maybe<IdsCriteria>;
  buildingUnits?: Maybe<MinMaxCriteria>;
  coBrokeAgreement?: Maybe<Scalars['Int']['output']>;
  collectYourOwnFee?: Maybe<IdsCriteria>;
  commonOutdoorSpace?: Maybe<IdsCriteria>;
  companies?: Maybe<Array<Scalars['String']['output']>>;
  constructionTypes?: Maybe<IdsCriteria>;
  contractLeaseSignedDate?: Maybe<DateRangeCriteria>;
  dealAgent?: Maybe<DealAgentCriteria>;
  exposures?: Maybe<IdsCriteria>;
  feeConcessions?: Maybe<IdsCriteria>;
  floors?: Maybe<FloorsCriteria>;
  furnished?: Maybe<IdsCriteria>;
  guarantors?: Maybe<IdsCriteria>;
  includeAlsoRentSaleListing?: Maybe<Scalars['Boolean']['output']>;
  includeNominalSales?: Maybe<Scalars['Boolean']['output']>;
  includeOtherApartmentTypes?: Maybe<Scalars['Boolean']['output']>;
  keyLocations?: Maybe<Array<Scalars['String']['output']>>;
  keyword?: Maybe<Scalars['String']['output']>;
  landLease?: Maybe<Scalars['Boolean']['output']>;
  leaseTerms?: Maybe<LeaseTermsCriteria>;
  leaseTypes?: Maybe<IdsCriteria>;
  listedDate?: Maybe<DateRangeCriteria>;
  listingCategoryId: ListingCategoryType;
  listingNumbers?: Maybe<Array<Scalars['String']['output']>>;
  listingTypes?: Maybe<IdsCriteria>;
  mapShapes?: Maybe<MapShapeCriteria>;
  maxMonthlyExpence?: Maybe<Scalars['Float']['output']>;
  miscellaneous?: Maybe<IdsCriteria>;
  multifloor?: Maybe<IdsCriteria>;
  neighborhoods?: Maybe<IdsCriteria>;
  offices?: Maybe<OfficesCriteria>;
  omniSearchCriteria?: Maybe<OmniSearchCriteria>;
  openHouse?: Maybe<OpenHouseCriteria>;
  ownerships?: Maybe<IdsCriteria>;
  postalCodes?: Maybe<Array<Scalars['String']['output']>>;
  price?: Maybe<PriceCriteria>;
  priceChange?: Maybe<PriceChangeCriteria>;
  privateOutdoorSpace?: Maybe<LogicalIdsCriteria>;
  rooms?: Maybe<RoomsCriteria>;
  soldOrRentedDate?: Maybe<DateRangeCriteria>;
  squareFootage?: Maybe<SquareFootageCriteria>;
  squareFootagePrice?: Maybe<SquareFootagePriceCriteria>;
  statusIds?: Maybe<IdsCriteria>;
  streetGrids?: Maybe<Array<StreetGridCriteria>>;
  townhouseFeatures?: Maybe<IdsCriteria>;
  townhouseSize?: Maybe<TownhouseSizeCriteria>;
  townhouseTypes?: Maybe<IdsCriteria>;
  updatedDate?: Maybe<DateRangeCriteria>;
  verifiedOnly?: Maybe<Scalars['Boolean']['output']>;
  views?: Maybe<LogicalIdsCriteria>;
  webNumbers?: Maybe<Array<Scalars['String']['output']>>;
  yearBuilt?: Maybe<MinMaxCriteria>;
};

export type SearchCriteriaInput = {
  addresses?: InputMaybe<Array<AddressCriteriaInput>>;
  agentPhones?: InputMaybe<Array<Scalars['String']['input']>>;
  agentTags?: InputMaybe<Array<Scalars['String']['input']>>;
  agents?: InputMaybe<AgentsCriteriaInput>;
  apartmentTypes?: InputMaybe<IdsCriteriaInput>;
  attendedLobby?: InputMaybe<LogicalIdsCriteriaInput>;
  availability?: InputMaybe<DateRangeCriteriaInput>;
  availableMedia?: InputMaybe<IdsCriteriaInput>;
  bathrooms?: InputMaybe<BathroomsCriteriaInput>;
  bedrooms?: InputMaybe<BedroomsCriteriaInput>;
  buildingAllowed?: InputMaybe<IdsCriteriaInput>;
  buildingAmenities?: InputMaybe<IdsCriteriaInput>;
  buildingContracts?: InputMaybe<BuildingContractsCriteriaInput>;
  buildingFinancing?: InputMaybe<MinMaxCriteriaInput>;
  buildingFloors?: InputMaybe<MinMaxCriteriaInput>;
  buildingManaged?: InputMaybe<IdsCriteriaInput>;
  buildingMarketed?: InputMaybe<IdsCriteriaInput>;
  buildingNotAllowed?: InputMaybe<IdsCriteriaInput>;
  buildingPeriod?: InputMaybe<IdsCriteriaInput>;
  buildingTypes?: InputMaybe<IdsCriteriaInput>;
  buildingUnits?: InputMaybe<MinMaxCriteriaInput>;
  coBrokeAgreement?: InputMaybe<Scalars['Int']['input']>;
  collectYourOwnFee?: InputMaybe<IdsCriteriaInput>;
  commonOutdoorSpace?: InputMaybe<IdsCriteriaInput>;
  companies?: InputMaybe<Array<Scalars['String']['input']>>;
  constructionTypes?: InputMaybe<IdsCriteriaInput>;
  contractLeaseSignedDate?: InputMaybe<DateRangeCriteriaInput>;
  dealAgent?: InputMaybe<DealAgentCriteriaInput>;
  exposures?: InputMaybe<IdsCriteriaInput>;
  feeConcessions?: InputMaybe<IdsCriteriaInput>;
  floors?: InputMaybe<FloorsCriteriaInput>;
  furnished?: InputMaybe<IdsCriteriaInput>;
  guarantors?: InputMaybe<IdsCriteriaInput>;
  includeAlsoRentSaleListing?: InputMaybe<Scalars['Boolean']['input']>;
  includeNominalSales?: InputMaybe<Scalars['Boolean']['input']>;
  includeOtherApartmentTypes?: InputMaybe<Scalars['Boolean']['input']>;
  keyLocations?: InputMaybe<Array<Scalars['String']['input']>>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  landLease?: InputMaybe<Scalars['Boolean']['input']>;
  leaseTerms?: InputMaybe<LeaseTermsCriteriaInput>;
  leaseTypes?: InputMaybe<IdsCriteriaInput>;
  listedDate?: InputMaybe<DateRangeCriteriaInput>;
  listingCategoryId: ListingCategoryType;
  listingNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  listingTypes?: InputMaybe<IdsCriteriaInput>;
  mapShapes?: InputMaybe<MapShapeCriteriaInput>;
  maxMonthlyExpence?: InputMaybe<Scalars['Float']['input']>;
  miscellaneous?: InputMaybe<IdsCriteriaInput>;
  multifloor?: InputMaybe<IdsCriteriaInput>;
  neighborhoods?: InputMaybe<IdsCriteriaInput>;
  offices?: InputMaybe<OfficesCriteriaInput>;
  omniSearchCriteria?: InputMaybe<OmniSearchCriteriaInput>;
  openHouse?: InputMaybe<OpenHouseCriteriaInput>;
  ownerships?: InputMaybe<IdsCriteriaInput>;
  postalCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  price?: InputMaybe<PriceCriteriaInput>;
  priceChange?: InputMaybe<PriceChangeCriteriaInput>;
  privateOutdoorSpace?: InputMaybe<LogicalIdsCriteriaInput>;
  rooms?: InputMaybe<RoomsCriteriaInput>;
  soldOrRentedDate?: InputMaybe<DateRangeCriteriaInput>;
  squareFootage?: InputMaybe<SquareFootageCriteriaInput>;
  squareFootagePrice?: InputMaybe<SquareFootagePriceCriteriaInput>;
  statusIds?: InputMaybe<IdsCriteriaInput>;
  streetGrids?: InputMaybe<Array<StreetGridCriteriaInput>>;
  townhouseFeatures?: InputMaybe<IdsCriteriaInput>;
  townhouseSize?: InputMaybe<TownhouseSizeCriteriaInput>;
  townhouseTypes?: InputMaybe<IdsCriteriaInput>;
  updatedDate?: InputMaybe<DateRangeCriteriaInput>;
  verifiedOnly?: InputMaybe<Scalars['Boolean']['input']>;
  views?: InputMaybe<LogicalIdsCriteriaInput>;
  webNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  yearBuilt?: InputMaybe<MinMaxCriteriaInput>;
};

export type SearchExtensions = {
  __typename?: 'SearchExtensions';
  buildingContractsByOmniSearch: Array<BuildingContract>;
  listingClusters: ListingClustersOutput;
  listingClustersByIds: ListingClustersOutput;
  listingCompaniesByOmniSearch: Array<ListingCompany>;
  listingsBounds?: Maybe<ClusterBounds>;
  listingsByCriteria: SearchListingsByCriteriaOutput;
  listingsByIds: Array<KeyValuePairOfInt32AndListingSearchViewModel>;
  listingsByPropertyIdAndCriteria: SearchListingsByCriteriaAndPropertyIdOutput;
  listingsIdsByCriteria: GetListingsIdsByCriteriaOutput;
  listingsPropertiesIds: Array<KeyValuePairOfInt32AndInt32>;
  neighborhoodsSerialized: Scalars['String']['output'];
  office: OfficeExtensions;
  omnibox: Array<OmniSearchResult>;
  rentSaleFlag?: Maybe<RentSaleFlagViewModel>;
  savedSearch: SavedSearchExtensions;
};


export type SearchExtensionsBuildingContractsByOmniSearchArgs = {
  text: Scalars['String']['input'];
};


export type SearchExtensionsListingClustersArgs = {
  input: ListingClustersInput;
};


export type SearchExtensionsListingClustersByIdsArgs = {
  input: ListingClustersByIdsInput;
};


export type SearchExtensionsListingCompaniesByOmniSearchArgs = {
  text: Scalars['String']['input'];
};


export type SearchExtensionsListingsBoundsArgs = {
  listingsIds: Array<Scalars['Int']['input']>;
};


export type SearchExtensionsListingsByCriteriaArgs = {
  input: SearchListingsByCriteriaInput;
};


export type SearchExtensionsListingsByIdsArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type SearchExtensionsListingsByPropertyIdAndCriteriaArgs = {
  input: SearchListingsByCriteriaAndPropertyIdInput;
};


export type SearchExtensionsListingsIdsByCriteriaArgs = {
  input: SearchListingsByCriteriaInput;
};


export type SearchExtensionsListingsPropertiesIdsArgs = {
  listingsIds: Array<Scalars['Int']['input']>;
};


export type SearchExtensionsOmniboxArgs = {
  listingCategory: ListingCategoryType;
  searchText: Scalars['String']['input'];
};


export type SearchExtensionsRentSaleFlagArgs = {
  listingId: Scalars['Int']['input'];
};

export type SearchListingsByCriteriaAndPropertyIdInput = {
  criteria: SearchCriteriaInput;
  propertyId: Scalars['Int']['input'];
};

export type SearchListingsByCriteriaAndPropertyIdOutput = {
  __typename?: 'SearchListingsByCriteriaAndPropertyIdOutput';
  listings: Array<ListingSearchViewModel>;
};

export type SearchListingsByCriteriaInput = {
  listingsIdsFilter?: InputMaybe<Array<Scalars['Int']['input']>>;
  options: SearchListingsOptionsInput;
};

export type SearchListingsByCriteriaOutput = {
  __typename?: 'SearchListingsByCriteriaOutput';
  agentSavedCriteriaId: Scalars['Int']['output'];
  bounds?: Maybe<ClusterBounds>;
  results: Array<ListingSearchViewModel>;
  took: Scalars['Float']['output'];
};

export type SearchListingsOptionsInput = {
  agentSavedCriteriaId?: InputMaybe<Scalars['Int']['input']>;
  customerId?: InputMaybe<Scalars['Int']['input']>;
  listingsSortingOptions: ListingsSortingField;
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  searchCriteria: SearchCriteriaInput;
  searchCriteriaName?: InputMaybe<Scalars['String']['input']>;
  sortingDirection: SortingDirection;
};

export type SoftDeleteAppointmentsInput = {
  appointmentsIds: Array<Scalars['Int']['input']>;
  collaborationId: Scalars['Int']['input'];
};

export enum SortingDirection {
  Ascending = 'ASCENDING',
  Descending = 'DESCENDING'
}

export type SquareFootageCriteria = {
  __typename?: 'SquareFootageCriteria';
  includeNoSqFt: Scalars['Boolean']['output'];
  minMax?: Maybe<MinMaxCriteria>;
};

export type SquareFootageCriteriaInput = {
  includeNoSqFt: Scalars['Boolean']['input'];
  minMax?: InputMaybe<MinMaxCriteriaInput>;
};

export type SquareFootagePriceCriteria = {
  __typename?: 'SquareFootagePriceCriteria';
  minMax?: Maybe<MinMaxCriteria>;
};

export type SquareFootagePriceCriteriaInput = {
  minMax?: InputMaybe<MinMaxCriteriaInput>;
};

export enum StorageType {
  BikeStorage = 'BIKE_STORAGE',
  No = 'NO',
  StorageOnly = 'STORAGE_ONLY',
  Unknown = 'UNKNOWN'
}

export type StoredMedia = {
  __typename?: 'StoredMedia';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isPortrait: Scalars['Boolean']['output'];
  kind: MediaKind;
  orientation: MediaOrientation;
  recordType: MediaRecordType;
  sequence: Scalars['Int']['output'];
  url: Scalars['String']['output'];
};

export type StreetGridCriteria = {
  __typename?: 'StreetGridCriteria';
  east?: Maybe<Scalars['Int']['output']>;
  north?: Maybe<Scalars['Int']['output']>;
  south?: Maybe<Scalars['Int']['output']>;
  west?: Maybe<Scalars['Int']['output']>;
};

export type StreetGridCriteriaInput = {
  east?: InputMaybe<Scalars['Int']['input']>;
  north?: InputMaybe<Scalars['Int']['input']>;
  south?: InputMaybe<Scalars['Int']['input']>;
  west?: InputMaybe<Scalars['Int']['input']>;
};

export type StreetGridViewModel = {
  __typename?: 'StreetGridViewModel';
  east?: Maybe<Scalars['Int']['output']>;
  north?: Maybe<Scalars['Int']['output']>;
  south?: Maybe<Scalars['Int']['output']>;
  west?: Maybe<Scalars['Int']['output']>;
};

export type SystemFoldersListingsCount = {
  __typename?: 'SystemFoldersListingsCount';
  all: Scalars['Int']['output'];
  emailed: Scalars['Int']['output'];
  external: Scalars['Int']['output'];
  notAssigned: Scalars['Int']['output'];
  removed: Scalars['Int']['output'];
};

export type TownhouseAttributes = {
  __typename?: 'TownhouseAttributes';
  numberOfUnits?: Maybe<Scalars['Int']['output']>;
};

export type TownhouseSizeCriteria = {
  __typename?: 'TownhouseSizeCriteria';
  minMaxUnits?: Maybe<MinMaxCriteria>;
  minMaxWidth?: Maybe<MinMaxCriteria>;
};

export type TownhouseSizeCriteriaInput = {
  minMaxUnits?: InputMaybe<MinMaxCriteriaInput>;
  minMaxWidth?: InputMaybe<MinMaxCriteriaInput>;
};

export type UpdateAgentAppointmentInput = {
  appointmentId: Scalars['Int']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
  end: Scalars['DateTime']['input'];
  start: Scalars['DateTime']['input'];
};

export type UpdateCommentTextInput = {
  commentId: Scalars['Int']['input'];
  customerCollaborationId: Scalars['Int']['input'];
  listingId: Scalars['Int']['input'];
  newText: Scalars['String']['input'];
  oldText: Scalars['String']['input'];
};

export type UpdateFolderInput = {
  customerId?: InputMaybe<Scalars['Int']['input']>;
  folderId: Scalars['Int']['input'];
  name: Scalars['String']['input'];
};

export type UpsertListingNoteInput = {
  customerId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  listingId: Scalars['Int']['input'];
  text: Scalars['String']['input'];
  type: ListingNoteType;
};

export type UpsertPushNotificationTokenOutput = {
  __typename?: 'UpsertPushNotificationTokenOutput';
  lastUpdated: Scalars['DateTime']['output'];
};

export type Value = {
  __typename?: 'Value';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type ValueOfAirConditioningType = {
  __typename?: 'ValueOfAirConditioningType';
  id: AirConditioningType;
  name: Scalars['String']['output'];
};

export type ValueOfAndOr = {
  __typename?: 'ValueOfAndOr';
  id: AndOr;
  name: Scalars['String']['output'];
};

export type ValueOfBuildingStorageType = {
  __typename?: 'ValueOfBuildingStorageType';
  id: BuildingStorageType;
  name: Scalars['String']['output'];
};

export type ValueOfExposure = {
  __typename?: 'ValueOfExposure';
  id: Exposure;
  name: Scalars['String']['output'];
};

export type ValueOfFeatureDetails = {
  __typename?: 'ValueOfFeatureDetails';
  id: FeatureDetails;
  name: Scalars['String']['output'];
};

export type ValueOfHealthclubType = {
  __typename?: 'ValueOfHealthclubType';
  id: HealthclubType;
  name: Scalars['String']['output'];
};

export type ValueOfHeatingType = {
  __typename?: 'ValueOfHeatingType';
  id: HeatingType;
  name: Scalars['String']['output'];
};

export type ValueOfLight = {
  __typename?: 'ValueOfLight';
  id: Light;
  name: Scalars['String']['output'];
};

export type ValueOfListingCategoryType = {
  __typename?: 'ValueOfListingCategoryType';
  id: ListingCategoryType;
  name: Scalars['String']['output'];
};

export type ValueOfListingType = {
  __typename?: 'ValueOfListingType';
  id: ListingType;
  name: Scalars['String']['output'];
};

export type ValueOfPrivateOutdoorSpace = {
  __typename?: 'ValueOfPrivateOutdoorSpace';
  id: PrivateOutdoorSpace;
  name: Scalars['String']['output'];
};

export type ValueOfStorageType = {
  __typename?: 'ValueOfStorageType';
  id: StorageType;
  name: Scalars['String']['output'];
};

export type ValueOfString = {
  __typename?: 'ValueOfString';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type ValueOfView = {
  __typename?: 'ValueOfView';
  id: View;
  name: Scalars['String']['output'];
};

export type ValueOfWasherDryer = {
  __typename?: 'ValueOfWasherDryer';
  id: WasherDryer;
  name: Scalars['String']['output'];
};

export type ValueOfYesNoUnknown = {
  __typename?: 'ValueOfYesNoUnknown';
  id: YesNoUnknown;
  name: Scalars['String']['output'];
};

export type ValuesCriteria = {
  __typename?: 'ValuesCriteria';
  values: Array<Scalars['Float']['output']>;
};

export type ValuesCriteriaInput = {
  values: Array<Scalars['Float']['input']>;
};

export type Video = {
  __typename?: 'Video';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isPortrait: Scalars['Boolean']['output'];
  kind: MediaKind;
  mode: VideoMode;
  orientation: MediaOrientation;
  recordType: MediaRecordType;
  sequence: Scalars['Int']['output'];
  type: VideoType;
  url: Scalars['String']['output'];
};

export enum VideoMode {
  Embed = 'EMBED',
  Url = 'URL'
}

export enum VideoType {
  Mp4Video = 'MP4_VIDEO',
  Unknown = 'UNKNOWN',
  Vimeo = 'VIMEO',
  Wellcomemat = 'WELLCOMEMAT',
  Youtube = 'YOUTUBE'
}

export enum View {
  Any = 'ANY',
  Bridges = 'BRIDGES',
  City = 'CITY',
  CityLights = 'CITY_LIGHTS',
  Downtown = 'DOWNTOWN',
  Garden = 'GARDEN',
  Panoramic = 'PANORAMIC',
  Park = 'PARK',
  PartialCity = 'PARTIAL_CITY',
  PartialGarden = 'PARTIAL_GARDEN',
  PartialPark = 'PARTIAL_PARK',
  PartialRiver = 'PARTIAL_RIVER',
  PartialSkyline = 'PARTIAL_SKYLINE',
  River = 'RIVER',
  RooftopsWithSky = 'ROOFTOPS_WITH_SKY',
  Skyline = 'SKYLINE',
  Street = 'STREET'
}

export type VirtualTour = {
  __typename?: 'VirtualTour';
  description?: Maybe<Scalars['String']['output']>;
  listingId: Scalars['Int']['output'];
  url: Scalars['String']['output'];
};

export enum WasherDryer {
  Allowed = 'ALLOWED',
  Hookups = 'HOOKUPS',
  InUnit = 'IN_UNIT',
  No = 'NO',
  Unknown = 'UNKNOWN'
}

export enum YesNoUnknown {
  No = 'NO',
  Unknown = 'UNKNOWN',
  Yes = 'YES'
}

export type CreateAppointmentCreatedNotificationMutationVariables = Exact<{
  input: AppointmentEventInput;
}>;


export type CreateAppointmentCreatedNotificationMutation = { __typename?: 'Mutation', notifications: { __typename?: 'NotificationsMutations', events: { __typename?: 'EventsMutations', appointmentCreated: { __typename?: 'AcknowledgeId', id: string } } } };

export type CreateAppointmentConfirmedNotificationMutationVariables = Exact<{
  input: AppointmentEventInput;
}>;


export type CreateAppointmentConfirmedNotificationMutation = { __typename?: 'Mutation', notifications: { __typename?: 'NotificationsMutations', events: { __typename?: 'EventsMutations', appointmentAccepted: { __typename?: 'AcknowledgeId', id: string } } } };

export type CreateAppointmentDeclinedNotificationMutationVariables = Exact<{
  input: AppointmentEventInput;
}>;


export type CreateAppointmentDeclinedNotificationMutation = { __typename?: 'Mutation', notifications: { __typename?: 'NotificationsMutations', events: { __typename?: 'EventsMutations', appointmentDeclined: { __typename?: 'AcknowledgeId', id: string } } } };

export type CreateAppointmentUpdatedNotificationMutationVariables = Exact<{
  input: AppointmentUpdatedEventInput;
}>;


export type CreateAppointmentUpdatedNotificationMutation = { __typename?: 'Mutation', notifications: { __typename?: 'NotificationsMutations', events: { __typename?: 'EventsMutations', appointmentUpdated: { __typename?: 'AcknowledgeId', id: string } } } };

export type CreateAppointmentDeletedNotificationMutationVariables = Exact<{
  input: AppointmentDeletedEventInput;
}>;


export type CreateAppointmentDeletedNotificationMutation = { __typename?: 'Mutation', notifications: { __typename?: 'NotificationsMutations', events: { __typename?: 'EventsMutations', appointmentDeleted: { __typename?: 'AcknowledgeId', id: string } } } };

export type CommentCreatedNotificationMutationVariables = Exact<{
  input: CommentCreatedInput;
}>;


export type CommentCreatedNotificationMutation = { __typename?: 'Mutation', notifications: { __typename?: 'NotificationsMutations', events: { __typename?: 'EventsMutations', commentCreated: { __typename?: 'AcknowledgeId', id: string } } } };

export type CommentUpdatedNotificationMutationVariables = Exact<{
  input: CommentUpdatedInput;
}>;


export type CommentUpdatedNotificationMutation = { __typename?: 'Mutation', notifications: { __typename?: 'NotificationsMutations', events: { __typename?: 'EventsMutations', commentUpdated: { __typename?: 'AcknowledgeId', id: string } } } };

export type FolderAddedNotificationMutationVariables = Exact<{
  input: FolderEventInput;
}>;


export type FolderAddedNotificationMutation = { __typename?: 'Mutation', notifications: { __typename?: 'NotificationsMutations', events: { __typename?: 'EventsMutations', folderAdded: { __typename?: 'AcknowledgeId', id: string } } } };

export type FolderUpdateNotificationMutationVariables = Exact<{
  input: FolderEventInput;
}>;


export type FolderUpdateNotificationMutation = { __typename?: 'Mutation', notifications: { __typename?: 'NotificationsMutations', events: { __typename?: 'EventsMutations', folderUpdated: { __typename?: 'AcknowledgeId', id: string } } } };

export type FolderRemovedNotificationMutationVariables = Exact<{
  input: FolderEventInput;
}>;


export type FolderRemovedNotificationMutation = { __typename?: 'Mutation', notifications: { __typename?: 'NotificationsMutations', events: { __typename?: 'EventsMutations', folderRemoved: { __typename?: 'AcknowledgeId', id: string } } } };

export type FolderListingsChangedNotificationMutationVariables = Exact<{
  input: FolderEventInput;
}>;


export type FolderListingsChangedNotificationMutation = { __typename?: 'Mutation', notifications: { __typename?: 'NotificationsMutations', events: { __typename?: 'EventsMutations', folderListingsChanged: { __typename?: 'AcknowledgeId', id: string } } } };

export type CreateNewListingActivityNotificationMutationVariables = Exact<{
  input: ListingActivityInput;
}>;


export type CreateNewListingActivityNotificationMutation = { __typename?: 'Mutation', notifications: { __typename?: 'NotificationsMutations', events: { __typename?: 'EventsMutations', newListingActivity: { __typename?: 'AcknowledgeId', id: string } } } };

export type CreateListingActivityChangedNotificationMutationVariables = Exact<{
  input: ListingActivityInput;
}>;


export type CreateListingActivityChangedNotificationMutation = { __typename?: 'Mutation', notifications: { __typename?: 'NotificationsMutations', events: { __typename?: 'EventsMutations', changedListingActivity: { __typename?: 'AcknowledgeId', id: string } } } };

export type CreateListingActivityRemovedNotificationMutationVariables = Exact<{
  input: NotificationsGraphQl_RemoveListingActivityInput;
}>;


export type CreateListingActivityRemovedNotificationMutation = { __typename?: 'Mutation', notifications: { __typename?: 'NotificationsMutations', events: { __typename?: 'EventsMutations', removeListingActivity: { __typename?: 'AcknowledgeId', id: string } } } };

export type CreateExternalListingAddedNotificationMutationVariables = Exact<{
  input: ExternalListingEventInput;
}>;


export type CreateExternalListingAddedNotificationMutation = { __typename?: 'Mutation', notifications: { __typename?: 'NotificationsMutations', events: { __typename?: 'EventsMutations', externalListingAdded: { __typename?: 'AcknowledgeId', id: string } } } };

export type CreateListingSoftDeletedNotificationMutationVariables = Exact<{
  input: ListingsEventInput;
}>;


export type CreateListingSoftDeletedNotificationMutation = { __typename?: 'Mutation', notifications: { __typename?: 'NotificationsMutations', events: { __typename?: 'EventsMutations', listingSoftDeleted: { __typename?: 'AcknowledgeId', id: string } } } };

export type CreateListingHardDeletedNotificationMutationVariables = Exact<{
  input: ListingsEventInput;
}>;


export type CreateListingHardDeletedNotificationMutation = { __typename?: 'Mutation', notifications: { __typename?: 'NotificationsMutations', events: { __typename?: 'EventsMutations', listingHardDeleted: { __typename?: 'AcknowledgeId', id: string } } } };

export type CreateListingRestoredNotificationMutationVariables = Exact<{
  input: ListingsEventInput;
}>;


export type CreateListingRestoredNotificationMutation = { __typename?: 'Mutation', notifications: { __typename?: 'NotificationsMutations', events: { __typename?: 'EventsMutations', listingRestored: { __typename?: 'AcknowledgeId', id: string } } } };

export type GetAllNotifiactionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllNotifiactionsQuery = { __typename?: 'Query', notifications: Array<{ __typename?: 'NotificationViewModel', isViewed: boolean, entityDate?: any | null, notificationId: number, listingId?: number | null, entityId: number, entityType: NotificationEntityType, collaborationId: number, createId: number, createDate: any, action: EventAction, comment?: { __typename?: 'CommentViewModel', text: string } | null, appointment?: { __typename?: 'AppointmentViewModel', createId: number, updateId?: number | null, agentStatus: NotificationsGraphQl_AppointmentStatus, customerStatus: NotificationsGraphQl_AppointmentStatus, startDateTime?: any | null, endDateTime?: any | null, comment?: string | null, isCreatedByAgent: boolean } | null, listing?: { __typename?: 'ListingViewModel', address: string, imageUrl?: string | null } | null }> };

export type ViewUnviewNotificationsMutationVariables = Exact<{
  notificationIds?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
}>;


export type ViewUnviewNotificationsMutation = { __typename?: 'Mutation', notifications: { __typename?: 'NotificationsMutations', viewUnviewNotifications: { __typename?: 'Acknowledge', success: boolean } } };

export type RemoveNotificationsByListingsMutationVariables = Exact<{
  input: RemoveNotificationsByListingsInput;
}>;


export type RemoveNotificationsByListingsMutation = { __typename?: 'Mutation', notifications: { __typename?: 'NotificationsMutations', removeByListings: { __typename?: 'Acknowledge', success: boolean } } };

export type RemoveNotificationsMutationVariables = Exact<{
  ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type RemoveNotificationsMutation = { __typename?: 'Mutation', notifications: { __typename?: 'NotificationsMutations', remove: { __typename?: 'Acknowledge', success: boolean } } };

export type RemoveEntitiesNotificationsMutationVariables = Exact<{
  input: RemoveByEntitiesInput;
}>;


export type RemoveEntitiesNotificationsMutation = { __typename?: 'Mutation', notifications: { __typename?: 'NotificationsMutations', removeByEntities: { __typename?: 'Acknowledge', success: boolean } } };

export type CreateUserDeactivatedNotificationMutationVariables = Exact<{
  userId: Scalars['Int']['input'];
}>;


export type CreateUserDeactivatedNotificationMutation = { __typename?: 'Mutation', notifications: { __typename?: 'NotificationsMutations', events: { __typename?: 'EventsMutations', userDeactivated: { __typename?: 'Acknowledge', success: boolean } } } };


export const CreateAppointmentCreatedNotificationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateAppointmentCreatedNotification"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AppointmentEventInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"notifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"events"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appointmentCreated"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CreateAppointmentCreatedNotificationMutation, CreateAppointmentCreatedNotificationMutationVariables>;
export const CreateAppointmentConfirmedNotificationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateAppointmentConfirmedNotification"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AppointmentEventInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"notifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"events"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appointmentAccepted"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CreateAppointmentConfirmedNotificationMutation, CreateAppointmentConfirmedNotificationMutationVariables>;
export const CreateAppointmentDeclinedNotificationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateAppointmentDeclinedNotification"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AppointmentEventInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"notifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"events"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appointmentDeclined"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CreateAppointmentDeclinedNotificationMutation, CreateAppointmentDeclinedNotificationMutationVariables>;
export const CreateAppointmentUpdatedNotificationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateAppointmentUpdatedNotification"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AppointmentUpdatedEventInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"notifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"events"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appointmentUpdated"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CreateAppointmentUpdatedNotificationMutation, CreateAppointmentUpdatedNotificationMutationVariables>;
export const CreateAppointmentDeletedNotificationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateAppointmentDeletedNotification"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AppointmentDeletedEventInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"notifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"events"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appointmentDeleted"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CreateAppointmentDeletedNotificationMutation, CreateAppointmentDeletedNotificationMutationVariables>;
export const CommentCreatedNotificationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CommentCreatedNotification"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CommentCreatedInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"notifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"events"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"commentCreated"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CommentCreatedNotificationMutation, CommentCreatedNotificationMutationVariables>;
export const CommentUpdatedNotificationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CommentUpdatedNotification"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CommentUpdatedInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"notifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"events"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"commentUpdated"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CommentUpdatedNotificationMutation, CommentUpdatedNotificationMutationVariables>;
export const FolderAddedNotificationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"FolderAddedNotification"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FolderEventInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"notifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"events"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"folderAdded"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<FolderAddedNotificationMutation, FolderAddedNotificationMutationVariables>;
export const FolderUpdateNotificationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"FolderUpdateNotification"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FolderEventInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"notifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"events"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"folderUpdated"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<FolderUpdateNotificationMutation, FolderUpdateNotificationMutationVariables>;
export const FolderRemovedNotificationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"FolderRemovedNotification"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FolderEventInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"notifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"events"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"folderRemoved"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<FolderRemovedNotificationMutation, FolderRemovedNotificationMutationVariables>;
export const FolderListingsChangedNotificationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"FolderListingsChangedNotification"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FolderEventInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"notifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"events"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"folderListingsChanged"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<FolderListingsChangedNotificationMutation, FolderListingsChangedNotificationMutationVariables>;
export const CreateNewListingActivityNotificationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateNewListingActivityNotification"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ListingActivityInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"notifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"events"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"newListingActivity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CreateNewListingActivityNotificationMutation, CreateNewListingActivityNotificationMutationVariables>;
export const CreateListingActivityChangedNotificationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateListingActivityChangedNotification"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ListingActivityInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"notifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"events"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"changedListingActivity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CreateListingActivityChangedNotificationMutation, CreateListingActivityChangedNotificationMutationVariables>;
export const CreateListingActivityRemovedNotificationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateListingActivityRemovedNotification"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"NotificationsGraphQL_RemoveListingActivityInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"notifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"events"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeListingActivity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CreateListingActivityRemovedNotificationMutation, CreateListingActivityRemovedNotificationMutationVariables>;
export const CreateExternalListingAddedNotificationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateExternalListingAddedNotification"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ExternalListingEventInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"notifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"events"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"externalListingAdded"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CreateExternalListingAddedNotificationMutation, CreateExternalListingAddedNotificationMutationVariables>;
export const CreateListingSoftDeletedNotificationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateListingSoftDeletedNotification"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ListingsEventInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"notifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"events"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listingSoftDeleted"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CreateListingSoftDeletedNotificationMutation, CreateListingSoftDeletedNotificationMutationVariables>;
export const CreateListingHardDeletedNotificationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateListingHardDeletedNotification"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ListingsEventInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"notifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"events"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listingHardDeleted"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CreateListingHardDeletedNotificationMutation, CreateListingHardDeletedNotificationMutationVariables>;
export const CreateListingRestoredNotificationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateListingRestoredNotification"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ListingsEventInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"notifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"events"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listingRestored"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CreateListingRestoredNotificationMutation, CreateListingRestoredNotificationMutationVariables>;
export const GetAllNotifiactionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAllNotifiactions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"notifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isViewed"}},{"kind":"Field","name":{"kind":"Name","value":"entityDate"}},{"kind":"Field","name":{"kind":"Name","value":"comment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}}]}},{"kind":"Field","name":{"kind":"Name","value":"appointment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createId"}},{"kind":"Field","name":{"kind":"Name","value":"updateId"}},{"kind":"Field","name":{"kind":"Name","value":"agentStatus"}},{"kind":"Field","name":{"kind":"Name","value":"customerStatus"}},{"kind":"Field","name":{"kind":"Name","value":"startDateTime"}},{"kind":"Field","name":{"kind":"Name","value":"endDateTime"}},{"kind":"Field","name":{"kind":"Name","value":"comment"}},{"kind":"Field","name":{"kind":"Name","value":"isCreatedByAgent"}}]}},{"kind":"Field","name":{"kind":"Name","value":"listing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"notificationId"}},{"kind":"Field","name":{"kind":"Name","value":"listingId"}},{"kind":"Field","name":{"kind":"Name","value":"entityId"}},{"kind":"Field","name":{"kind":"Name","value":"entityType"}},{"kind":"Field","name":{"kind":"Name","value":"collaborationId"}},{"kind":"Field","name":{"kind":"Name","value":"createId"}},{"kind":"Field","name":{"kind":"Name","value":"createDate"}},{"kind":"Field","name":{"kind":"Name","value":"action"}}]}}]}}]} as unknown as DocumentNode<GetAllNotifiactionsQuery, GetAllNotifiactionsQueryVariables>;
export const ViewUnviewNotificationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ViewUnviewNotifications"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"notificationIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"notifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewUnviewNotifications"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"notificationIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"notificationIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]}}]} as unknown as DocumentNode<ViewUnviewNotificationsMutation, ViewUnviewNotificationsMutationVariables>;
export const RemoveNotificationsByListingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveNotificationsByListings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RemoveNotificationsByListingsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"notifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeByListings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]}}]} as unknown as DocumentNode<RemoveNotificationsByListingsMutation, RemoveNotificationsByListingsMutationVariables>;
export const RemoveNotificationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveNotifications"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"notifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"remove"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"notificationIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]}}]} as unknown as DocumentNode<RemoveNotificationsMutation, RemoveNotificationsMutationVariables>;
export const RemoveEntitiesNotificationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveEntitiesNotifications"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RemoveByEntitiesInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"notifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeByEntities"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]}}]} as unknown as DocumentNode<RemoveEntitiesNotificationsMutation, RemoveEntitiesNotificationsMutationVariables>;
export const CreateUserDeactivatedNotificationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateUserDeactivatedNotification"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"notifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"events"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userDeactivated"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CreateUserDeactivatedNotificationMutation, CreateUserDeactivatedNotificationMutationVariables>;